/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Shield,
  Edit,
  Trash2,
  Search,
  RefreshCw,
  UserCheck,
  FileText,
  ChevronDown,
  ChevronUp,
  AlertCircle,
  X,
  Check,
  Plus,
  ArrowLeft,
  UserCog,
} from "lucide-react";
import axios from "axios";
import { NODE_BACKEND_URL } from "../utils/constant";
import { getAuthToken, successMessage } from "../utils/helpers";
import { goToLogin } from "../utils/navigation";


// Import role configuration
import {
  ROLE_DEFINITIONS,
  ROLE_TYPES,
  getAllRoles,
  getRoleDisplayName,
} from "../config/roleConfig";

const CustomSelect = ({ options, value, onChange, classes }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
  <div className={classes}>
  <button
  className="w-full px-3 py-2 pr-8 text-xs text-left border rounded-lg bg-[#111111] border-[#1A1A1A] text-[#F5F5F5]"
  onClick={() => setIsOpen(!isOpen)}
  >
  {value || "All Roles"}
  <span className="absolute transform -translate-y-1/2 right-3 top-1/2">
  <ChevronDown className="w-4 h-4" />
  </span>
  </button>

  {isOpen && (
  <div
  className="absolute z-10 w-full mt-1 border rounded-lg shadow-lg bg-[#111111] border-[#1A1A1A]"
  >
  {options.map((option) => (
  <div
  key={option.value}
  className={`px-3 py-2 text-xs cursor-pointer text-[#F5F5F5] hover:bg-[#E8B800] hover:text-black ${
  value === option.value
  ? "bg-[#E8B800] text-black font-medium"
  : ""
  }`}
  onClick={() => {
  onChange(option.value);
  setIsOpen(false);
  }}
  >
  {option.label}
  </div>
  ))}
  </div>
  )}
  </div>
  );
};

const SportModal = ({
  mode = "add",
  onClose,
  isSportModalOpen,
  onSubmit,
  newSport,
  setNewSport,
  error,
  isLoading,
}) => {
  if (!isSportModalOpen) return null;
  const handleCancel = () => {
  onClose();
  };

  return (
  <div className="fixed inset-0 z-50 overflow-y-auto">
  {/* Backdrop */}
  <div className="fixed inset-0 transition-opacity bg-black/60"></div>

  {/* Modal container */}
  <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
  {/* This element is to trick the browser into centering the modal contents */}
  <span
  className="hidden sm:inline-block sm:align-middle sm:h-screen"
  aria-hidden="true"
  >
  &#8203;
  </span>

  {/* Modal content */}
  <div
  className="inline-block align-bottom transition-all transform bg-[#111111] shadow-xl rounded-[14px] sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
  onClick={(e) => e.stopPropagation()} // Prevent click from bubbling to backdrop
  >
  <div className="p-6">
  <div className="pb-4 text-left border-[#1A1A1A] border-b">
  <h3 className="text-xl font-medium text-[#F5F5F5]">
  {mode === "add" ? "Add New Sport" : "Edit Sport"}
  </h3>
  </div>

  {error && (
  <div className="px-4 py-3 mt-4 mb-4 border rounded-lg shadow-sm text-red-300 border-red-800 bg-red-900/30">
  <div className="flex items-center">
  <AlertCircle className="flex-shrink-0 w-5 h-5 mr-2" />
  <span>{error}</span>
  </div>
  </div>
  )}

  <div className="mt-6">
  <div className="mb-6">
  <div className="mb-6">
  <label
  htmlFor="sport-name"
  className="block mb-1 text-sm font-medium text-left text-[#999999]"
  >
  Sport Name *
  </label>
  <input
  type="text"
  id="sport-name"
  value={newSport.name}
  onChange={(e) =>
  setNewSport({ ...newSport, name: e.target.value })
  }
  className="block w-full p-3 border rounded-md shadow-sm focus:ring-[#E8B800] focus:border-[#E8B800] sm:text-sm border-[#1A1A1A] bg-[#0A0A0A] text-[#F5F5F5] placeholder-[#555555]"
  placeholder="e.g. Basketball"
  required
  />
  </div>

  <div className="mb-6">
  <label
  htmlFor="sport-code"
  className="block mb-1 text-sm font-medium text-left text-[#999999]"
  >
  Sport Code *
  </label>
  <input
  type="text"
  id="sport-code"
  value={newSport.code}
  onChange={(e) =>
  setNewSport({ ...newSport, code: e.target.value })
  }
  className="block w-full p-3 border rounded-md shadow-sm focus:ring-[#E8B800] focus:border-[#E8B800] sm:text-sm border-[#1A1A1A] bg-[#0A0A0A] text-[#F5F5F5] placeholder-[#555555]"
  placeholder="e.g. BBALL"
  required
  />
  <p className="mt-1 text-sm text-left text-[#555555]">
  A short, unique code to identify this sport
  </p>
  </div>

  <div className="flex items-center mb-4">
  <input
  type="checkbox"
  id="sport-enabled"
  checked={newSport.isEnable}
  onChange={(e) =>
  setNewSport({ ...newSport, isEnable: e.target.checked })
  }
  className="w-4 h-4 text-[#E8B800] rounded bg-[#0A0A0A] border-[#1A1A1A]"
  />
  <label
  htmlFor="sport-enabled"
  className="block ml-2 text-sm text-[#999999]"
  >
  Active
  </label>
  </div>
  </div>

  <div className="flex justify-end pt-3 space-x-3 border-t border-[#1A1A1A]">
  <button
  type="button"
  onClick={handleCancel}
  className="px-4 py-2 text-sm font-medium border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E8B800] text-[#999999] bg-[#111111] border-[#1A1A1A] hover:bg-[rgba(255,255,255,0.04)]"
  >
  Cancel
  </button>
  <button
  type="button"
  onClick={() => onSubmit(newSport)}
  disabled={isLoading || !newSport.name || !newSport.code}
  className={`px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-black ${
  isLoading || !newSport.name || !newSport.code
  ? "bg-[#E8B800]/50 cursor-not-allowed"
  : "bg-[#E8B800] hover:bg-[#D4A800]"
  } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E8B800]`}
  >
  {isLoading ? (
  <span className="flex items-center justify-center">
  <svg
  className="w-4 h-4 mr-2 -ml-1 text-black animate-spin"
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  >
  <circle
  className="opacity-25"
  cx="12"
  cy="12"
  r="10"
  stroke="currentColor"
  strokeWidth="4"
  ></circle>
  <path
  className="opacity-75"
  fill="currentColor"
  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  ></path>
  </svg>
  {mode === "add" ? "Creating..." : "Saving..."}
  </span>
  ) : mode === "add" ? (
  "Create Sport"
  ) : (
  "Save Changes"
  )}
  </button>
  </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  );
};

const PermissionTemplateModal = ({
  isTemplateModalOpen,
  onClose,
  onSubmit,
  isSubmitting,
  templateError,
  adminRoutes,
  templateData,
  setTemplateData,
  updatingTemplate,
  togglePermission,
  isPermissionSelected,
  sports,
  loadingSports,
  teamsData,
  loadingTeams,
  expandedSports,
  isSportExpanded,
  setIsSportExpanded,
  toggleSportExpansion,
  handleSportCheckBox,
  mode = "add",
}) => {
  if (!isTemplateModalOpen) return null;

  const groupedPermissions = {};
  const routePermissions = [];

  // Group permissions by sport and separate route permissions
  templateData.permissions.forEach((permission) => {
  if (permission.routePath) {
  // This is a route permission
  routePermissions.push(permission);
  } else if (permission.sportId) {
  // This is a sport/team permission
  const sportId = permission.sportId;
  if (!groupedPermissions[sportId]) {
  groupedPermissions[sportId] = {
  sportName: permission.sportName,
  sportCode: permission.sportCode,
  teams: [],
  };
  }

  if (permission.teamId) {
  groupedPermissions[sportId].teams.push({
  teamId: permission.teamId,
  teamName: permission.teamName,
  teamNickname: permission.teamNickname,
  });
  }
  }
  });

  // Define permission groups based on navSections
  const permissionGroups = [
  {
  id: "main",
  title: "MAIN",
  permissions: [
  {
  routePath: "/dashboard",
  name: "How it works",
  description: "Access to dashboard and how it works page",
  },
  {
  routePath: "/myDashboard",
  name: "My Dashboard",
  description: "Access to personal dashboard",
  },
  {
  routePath: "/ask-benny",
  name: "SLAM AI",
  description: "Access to SLAM AI assistant",
  },
  {
  routePath: "/saved-pages",
  name: "Save pages",
  description: "Access to chat functionality",
  },
  ],
  },
  {
  id: "roster",
  title: "Scouting",
  permissions: [
  // { routePath: "/top-matches", name: "Top Matches" },
  // { routePath: "/decision-making", name: "Decision Making" },
  // { routePath: "/personality-fit", name: "Cultural Fit" },
  {
  routePath: "/player-roster",
  name: "Roster Management",
  description: "Access to player roster management",
  },
  ],
  },
  {
  id: "development",
  title: "PLAYER DEVELOPMENT",
  permissions: [
  // { routePath: "/performance-trends", name: "Performance Trends" },
  // { routePath: "/injury-risk", name: "Injury Risk" },
  {
  routePath: "/video-analytics",
  name: "Video Analytics",
  description: "Access to video analytics tools",
  },
  // { routePath: "/data-upload", name: "Synergy Video" }
  ],
  },
  {
  id: "recruiting",
  title: "Recruiting",
  permissions: [
  {
  routePath: "/scouting",
  name: "Player Portal",
  description: "Access to scouting and matching tools",
  },
  // { routePath: "/pre-college-player", name: "PreCollege Players" }
  ],
  },
  {
  id: "nil",
  title: "NIL",
  permissions: [
  // { routePath: "/nil-valuation", name: "NIL Valuation" },
  // { routePath: "/nil-forecasting", name: "NIL Forecasting" },
  {
  routePath: "/development",
  name: "Valuation",
  description: "Access to development features",
  },
  // { routePath: "/monetization", name: "Monetization" }
  ],
  },
  {
  id: "system",
  title: "SYSTEM",
  permissions: [
  {
  routePath: "/reports",
  name: "Reports",
  description: "Access to reports generation",
  },
  ...(adminRoutes
  ? [{ routePath: "/permissions", name: "Permissions" }]
  : []),
  {
  routePath: "/settings",
  name: "Settings",
  description: "Access to system settings",
  },
  {
  routePath: "/integrations",
  name: "Integrations",
  description: "Access to integrations management",
  },
  ],
  },
  ];

  // Toggle individual permission
  const toggleIndividualPermission = (permission) => {
  setTemplateData((prev) => {
  // Check if permission already exists
  const permissionExists = prev.permissions.some(
  (p) =>
  p.routePath === permission.routePath ||
  p.routePath === permission.routePath
  );

  return {
  ...prev,
  permissions: permissionExists
  ? prev.permissions.filter(
  (p) =>
  !(
  p.routePath === permission.routePath ||
  p.routePath === permission.routePath
  )
  )
  : [...prev.permissions, permission],
  };
  });
  };

  const toggleGroupPermissions = (group) => {
  const groupPermissionIds = group.permissions.map((p) => p.routePath);

  // Check if all permissions in the group are already selected
  const allInGroupSelected = groupPermissionIds.every((routePath) =>
  templateData.permissions.some(
  (p) => p.routePath === routePath || p.routePath === routePath
  )
  );

  let newPermissions = [];

  if (allInGroupSelected) {
  // Remove all permissions from this group
  newPermissions = templateData.permissions.filter(
  (p) => !groupPermissionIds.includes(p.routePath || p.routePath)
  );
  } else {
  // Add all permissions from this group that aren't already present
  newPermissions = [
  ...templateData.permissions,
  ...group.permissions
  .filter(
  (p) =>
  !templateData.permissions.some(
  (existing) =>
  existing.routePath === p.routePath ||
  existing.routePath === p.routePath
  )
  )
  .map((p) => ({
  routePath: p.routePath,
  id: p.routePath,
  label: p.name || p.routePath,
  sportId: null,
  teamId: null,
  })),
  ];
  }

  setTemplateData({ ...templateData, permissions: newPermissions });
  };

  // Get all permission IDs
  const allPermissionIds = permissionGroups.flatMap((group) =>
  group.permissions.map((p) => p.routePath)
  );
  // Toggle all permissions
  const toggleSelectAll = () => {
  const allPermissions = permissionGroups.flatMap(
  (group) => group.permissions
  );
  setTemplateData({
  ...templateData,
  permissions:
  templateData.permissions.length === allPermissions.length
  ? []
  : allPermissions,
  });
  };

  const selectedPermissionsCount = templateData.permissions.filter(
  (p) => p?.name || p?.routePath || p?.label
  ).length;

  const allSelected = selectedPermissionsCount === allPermissionIds.length;

  return (
  <div className="fixed inset-0 z-50 overflow-y-auto">
  {/* Backdrop */}
  <div
  className="fixed inset-0 transition-opacity bg-black/70"
  onClick={onClose}
  ></div>

  {/* Modal container */}
  <div className="flex items-center justify-center min-h-screen px-4 pb-20 text-center sm:block sm:p-0">
  <div
  className="inline-block align-bottom transition-all transform shadow-xl rounded-[14px] sm:my-4 sm:align-middle sm:max-w-4xl sm:w-full bg-[#0A0A0A]"
  >
  {/* Modal content */}
  <div className="p-4">
  {/* Header */}
  <div className="flex items-center justify-between">
  <div>
  <h3
  className="text-lg font-semibold text-left text-[#F5F5F5]"
  >
  {mode === "add" ? "Add New Template" : "Edit Template"}
  </h3>
  {mode === "edit" && (
  <p className="mt-1 text-sm text-left text-[#555555]">
  Update template details and permissions
  </p>
  )}
  </div>
  <div className="flex items-center space-x-2">
  <button
  onClick={onClose}
  className="p-2 transition-colors rounded-full text-[#555555] hover:text-[#999999] hover:bg-[rgba(255,255,255,0.04)]"
  >
  <X className="w-5 h-5" />
  </button>
  </div>
  </div>

  {/* Error message */}
  {templateError && (
  <div
  className="px-4 py-3 mb-4 border rounded-lg shadow-sm text-red-300 border-red-800 bg-red-900/50"
  >
  <div className="flex items-center">
  <AlertCircle className="flex-shrink-0 w-5 h-5 mr-2" />
  <span>{templateError}</span>
  </div>
  </div>
  )}

  {/* Modal body */}
  <div className="space-y-4 max-h-[calc(100vh-200px)] overflow-y-auto">
  {/* Basic Information */}
  <div className="px-2 py-2">
  <div className="flex flex-col gap-4">
  <div className="text-left">
  <label
  htmlFor="template-name"
  className="block mb-2 text-sm font-medium text-left text-[#999999]"
  >
  Template Name *
  </label>
  <input
  type="text"
  name="template-name"
  id="template-name"
  value={templateData.name}
  onChange={(e) =>
  setTemplateData({
  ...templateData,
  name: e.target.value,
  })
  }
  className="block w-full p-3 text-sm text-left border rounded-lg shadow-sm focus:ring-[#E8B800] focus:border-[#E8B800] focus:outline-none bg-[#111111] border-[#1A1A1A] text-[#F5F5F5] placeholder-[#555555] hover:border-[#333333]"
  placeholder="e.g. Basketball Coach"
  />
  </div>

  <div className="text-left">
  <label
  htmlFor="template-description"
  className="block mb-2 text-sm font-medium text-left text-[#999999]"
  >
  Description
  </label>
  <textarea
  id="template-description"
  name="template-description"
  rows={3}
  value={templateData.description}
  onChange={(e) =>
  setTemplateData({
  ...templateData,
  description: e.target.value,
  })
  }
  className="block w-full p-3 text-sm text-left border rounded-lg shadow-sm resize-none focus:ring-[#E8B800] focus:border-[#E8B800] focus:outline-none bg-[#111111] border-[#1A1A1A] text-[#F5F5F5] placeholder-[#555555] hover:border-[#1A1A1A]"
  placeholder="Describe what this permission template is for"
  />
  </div>

  {/* Role Type Selector */}
  <div className="text-left">
  <label
  htmlFor="template-role-type"
  className="block mb-2 text-sm font-medium text-left text-[#999999]"
  >
  <div className="flex items-center gap-2">
  <UserCog size={16} />
  Role Type
  </div>
  <span className="text-xs font-normal text-[#555555]">
  Assign this template to a specific user role for easier management
  </span>
  </label>
  <select
  id="template-role-type"
  name="template-role-type"
  value={templateData.roleType || ""}
  onChange={(e) =>
  setTemplateData({
  ...templateData,
  roleType: e.target.value,
  })
  }
  className="block w-full p-3 text-sm text-left border rounded-lg shadow-sm focus:ring-[#E8B800] focus:border-[#E8B800] focus:outline-none bg-[#111111] border-[#1A1A1A] text-[#F5F5F5] hover:border-[#1A1A1A]"
  >
  <option value="">Select a role type (optional)</option>
  {getAllRoles().map((role) => (
  <option key={role.id} value={role.id}>
  {role.name} - {role.description}
  </option>
  ))}
  </select>
  </div>
  </div>
  </div>

  {/* Route Permissions Section */}
  <div>
  <div className="flex items-center justify-between mb-4">
  <div className="text-left">
  <h4
  className="text-lg font-semibold text-left text-[#F5F5F5]"
  >
  Assigned Permissions
  </h4>
  <p
  className="mt-1 text-sm text-left text-[#555555]"
  >
  Select which permissions to assign to this role
  </p>
  </div>
  <div className="flex items-center space-x-2">
  <label className="flex items-center space-x-2 text-sm cursor-pointer">
  <input
  type="checkbox"
  checked={allSelected}
  onChange={toggleSelectAll}
  className="w-3 h-3 text-[#E8B800] rounded"
  />
  <span
  className="text-xs text-[#999999]"
  >
  {allSelected ? "Deselect All" : "Select All"}
  </span>
  </label>
  </div>
  </div>
  <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
  {permissionGroups.map((group) => {
  let allInGroupSelected = false;
  if (mode === "add") {
  const groupPermissionIds = group.permissions.map(
  (p) => p.routePath
  );
  allInGroupSelected = groupPermissionIds.every(
  (routePath) =>
  templateData.permissions
  .map((p) => p.routePath || p.routePath)
  .includes(routePath)
  );
  } else {
  const groupPermissionIds = group.permissions.map(
  (p) => p.routePath
  );
  allInGroupSelected = groupPermissionIds.every(
  (routePath) =>
  templateData.permissions
  .map((p) => p.routePath || p.routePath)
  .includes(routePath)
  );
  }
  return (
  <div
  key={group.routePath}
  className="p-3 border rounded-lg border-[#1A1A1A]"
  >
  <div className="flex items-center justify-between mb-3">
  <h5
  className="font-medium text-md text-[#F5F5F5]"
  >
  {group.title}
  </h5>
  <label className="flex items-center space-x-2 cursor-pointer">
  <button
  type="button"
  onClick={() => toggleGroupPermissions(group)}
  className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors focus:outline-none ${
  allInGroupSelected
  ? "bg-[#E8B800]"
  : "bg-[#111111]"
  }`}
  aria-pressed={allInGroupSelected}
  >
  <span
  className={`inline-block h-4 w-4 transform rounded-full shadow transition-transform ${
  allInGroupSelected
  ? `translate-x-5 bg-[#111111]`
  : `translate-x-0.5 bg-[#555555]`
  }`}
  />
  </button>
  </label>
  </div>
  <div className="grid grid-cols-1 gap-3">
  {group.permissions.map((permission) => (
  <div
  key={permission.routePath}
  className={`flex items-center rounded-lg cursor-pointer transition-colors ${
  templateData.permissions
  .map((p) => p.routePath || p.routePath)
  .includes(permission.routePath)
  ? `border bg-[#111111] border-[#1A1A1A]`
  : "hover:bg-[#111111] border border-transparent"
  }`}
  >
  <input
  type="checkbox"
  checked={templateData.permissions
  .map((p) => p.routePath || p.routePath)
  .includes(permission.routePath)}
  onChange={() =>
  toggleIndividualPermission(permission)
  }
  className="w-3 h-3 mr-3 text-[#E8B800] rounded"
  />
  <span
  className="text-xs text-[#999999]"
  >
  {permission.name}
  </span>
  </div>
  ))}
  </div>
  </div>
  );
  })}
  </div>

  {/* Selected Permissions Summary */}
  {selectedPermissionsCount > 0 && (
  <div
  className="p-3 mt-4 border rounded-lg border-purple-800 bg-purple-900/50"
  >
  <p
  className="text-sm font-medium text-left text-purple-300"
  >
  Selected Permissions ({selectedPermissionsCount}):
  </p>
  <div className="flex flex-wrap gap-1 mt-2">
  {mode === "add"
  ? templateData.permissions.map((permission, index) =>
  permission?.name || permission?.routePath ? (
  <span
  key={index}
  className="px-2 py-1 text-xs rounded-full text-purple-300 bg-purple-800"
  >
  {
  permissionGroups
  .flatMap((g) => g.permissions)
  .find(
  (p) =>
  p.routePath === permission?.routePath
  )?.name
  }
  </span>
  ) : null
  )
  : templateData.permissions.map((permission, index) =>
  permission?.name || permission?.routePath ? (
  <span
  key={index}
  className="px-2 py-1 text-xs rounded-full text-purple-300 bg-purple-800"
  >
  {
  permissionGroups
  .flatMap((g) => g.permissions)
  .find(
  (p) =>
  p.routePath === permission?.routePath
  )?.name
  }
  </span>
  ) : null
  )}
  </div>
  </div>
  )}

  <div className="flex items-center justify-between my-4">
  <div className="text-left">
  <h4
  className="text-lg font-semibold text-left text-[#F5F5F5]"
  >
  Teams can access
  </h4>
  </div>
  </div>
  <div className="relative grid grid-cols-1 gap-3 md:grid-cols-2">
  <div
  className="rounded-md bg-[#111111]"
  >
  {templateError && (
  <div
  className="relative px-4 py-3 mb-6 border rounded text-red-300 bg-red-900/50 border-red-800"
  >
  <span className="flex items-center">
  <AlertCircle className="w-5 h-5 mr-2" />
  {templateError}
  </span>
  </div>
  )}

  {/* Success message */}
  {!updatingTemplate && !templateError && (
  <div
  className="relative px-4 py-3 mb-6 border rounded text-green-300 bg-green-900/50 border-green-800"
  style={{ display: "none" }}
  id="success-message"
  >
  <span className="flex items-center">
  <Shield className="w-5 h-5 mr-2" />
  Template updated successfully!
  </span>
  </div>
  )}

  {/* Sports & Teams Permissions Section */}
  <div className="py-4 mb-8">
  <div className="flex items-center justify-between mb-4">
  <div className="text-left">
  <span
  className="px-3 py-1 text-sm rounded-full text-blue-300 bg-blue-900/50"
  >
  {Object.keys(groupedPermissions).length} sports,{" "}
  {Object.values(groupedPermissions).reduce(
  (total, sport) => total + sport.teams.length,
  0
  )}{" "}
  teams
  </span>
  <h2
  className="text-base font-semibold text-left text-[#F5F5F5]"
  >
  Sports & Teams Permissions
  </h2>
  <p
  className="mt-1 text-sm text-left text-[#555555]"
  >
  Grant access to specific sports and their teams
  </p>
  </div>
  </div>

  {loadingSports ? (
  <div className="py-8 text-center">
  <div className="w-10 h-10 mx-auto border-b-2 border-blue-700 rounded-full animate-spin"></div>
  <p
  className="mt-2 text-[#555555]"
  >
  Loading sports...
  </p>
  </div>
  ) : sports.length === 0 ? (
  <div
  className="py-8 text-center text-[#555555]"
  >
  <Shield className="w-12 h-12 mx-auto mb-4 text-[#999999]" />
  <p>No sports available. Please add sports first.</p>
  </div>
  ) : (
  <div className="space-y-4">
  {sports
  .filter((sport) => sport.isEnable)
  .map((sport) => {
  const sportTeams = teamsData[sport.code] || [];
  const isLoading =
  loadingTeams && sportTeams.length === 0;
  const selectedTeamsCount = sportTeams.filter(
  (team) =>
  isPermissionSelected(
  sport.id,
  team.TeamID.toString()
  )
  ).length;
  const allTeamsSelected =
  sportTeams.length > 0 &&
  selectedTeamsCount === sportTeams.length;
  const someTeamsSelected =
  selectedTeamsCount > 0 &&
  selectedTeamsCount < sportTeams.length;

  return (
  <div
  key={sport.id}
  className="overflow-hidden border border-[#1A1A1A] rounded-lg sport-container"
  data-sport-id={sport.id}
  >
  <div
  className={`p-4 flex items-center transition-colors ${
  allTeamsSelected
  ? `bg-green-500 border-green-700`
  : someTeamsSelected
  ? `bg-blue-500 border-blue-700`
  : "bg-[#111111]"
  }`}
  >
  <input
  type="checkbox"
  id={`sport-${sport.id}`}
  className="w-4 h-4 mr-3 text-sm text-blue-600 rounded"
  checked={allTeamsSelected}
  onChange={async () => {
  const updatedTeams =
  await handleSportCheckBox(sport.id);

  const teamsToUse =
  updatedTeams?.length > 0
  ? updatedTeams
  : sportTeams;

  // Get currently selected team IDs for this sport
  const selectedTeamIds =
  templateData.permissions
  .filter(
  (p) => p.sportId === sport.id
  )
  .map((p) => p.teamId);

  const allTeamIds = teamsToUse.map(
  (team) => team.TeamID.toString()
  );

  const areAllSelected =
  selectedTeamIds.length ===
  allTeamIds.length;
  const areSomeSelected =
  selectedTeamIds.length > 0 &&
  !areAllSelected;

  if (areAllSelected) {
  // ✅ Case 1: All selected → Remove all
  setTemplateData((prev) => ({
  ...prev,
  permissions:
  prev.permissions.filter(
  (p) => p.sportId !== sport.id
  ),
  }));
  } else {
  // ✅ Case 2: None or Some selected → Select missing ones
  const missingTeamIds =
  allTeamIds.filter(
  (id) =>
  !selectedTeamIds.includes(id)
  );

  const newPermissions =
  missingTeamIds.map((id) => ({
  sportId: sport.id,
  teamId: id,
  }));

  setTemplateData((prev) => ({
  ...prev,
  permissions: [
  ...prev.permissions,
  ...newPermissions,
  ],
  }));
  }
  }}
  />
  <label
  htmlFor={`sport-${sport.id}`}
  className="flex items-center flex-1 text-base font-medium text-[#F5F5F5]"
  >
  {sport.name}
  <span
  className="ml-2 px-2 py-0.5 text-xs rounded-full bg-blue-900/50 text-blue-300"
  >
  {sport.code}
  </span>
  {someTeamsSelected && (
  <span
  className="ml-2 px-2 py-0.5 text-[8px] rounded-full bg-orange-900/50 text-orange-300"
  >
  {selectedTeamsCount} of{" "}
  {sportTeams.length} teams
  </span>
  )}
  {allTeamsSelected && (
  <span
  className="ml-2 px-2 py-0.5 text-xs rounded-full bg-green-900/50 text-green-300"
  >
  All {sportTeams.length} teams
  </span>
  )}
  <span
  className="ml-2 text-xs teams-count text-[#555555]"
  style={{ display: "none" }}
  ></span>
  </label>
  <div className="ml-auto">
  <button
  onClick={() => {
  toggleSportExpansion(sport.id);
  }}
  className="p-1 rounded-md focus:outline-none text-[#555555] hover:text-[#F5F5F5] hover:bg-[#0A0A0A]"
  >
  {expandedSports.includes(sport.id) ? (
  <ChevronUp size={20} />
  ) : (
  <ChevronDown size={20} />
  )}
  </button>
  </div>
  </div>

  {expandedSports.includes(sport.id) && (
  <div
  className="border-t w-[380px] h-full absolute right-5 top-1 p-4 overflow-hidden bg-[#111111] border-[#1A1A1A]"
  >
  <div className="mb-4">
  <div className="relative">
  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
  <Search
  className="w-4 h-4 text-[#555555]"
  />
  </div>
  <input
  type="text"
  placeholder="Search teams..."
  className="w-full py-2 pl-10 pr-3 text-sm border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 bg-[#0A0A0A] border-[#1A1A1A] text-[#F5F5F5] placeholder-[#555555]"
  onChange={(e) => {
  const searchTerm =
  e.target.value.toLowerCase();
  document
  .getElementById(
  "edit-teams-container"
  )
  .setAttribute(
  "data-search",
  searchTerm
  );

  const teamItems =
  document.querySelectorAll(
  ".team-item"
  );
  teamItems.forEach((item) => {
  const teamName = item
  .getAttribute(
  "data-team-name"
  )
  .toLowerCase();
  if (
  searchTerm === "" ||
  teamName.includes(searchTerm)
  ) {
  item.style.display = "flex";
  } else {
  item.style.display = "none";
  }
  });

  const sportContainers =
  document.querySelectorAll(
  ".sport-container"
  );
  sportContainers.forEach(
  (container) => {
  const sportId =
  container.getAttribute(
  "data-sport-id"
  );
  const visibleTeams =
  container.querySelectorAll(
  '.team-item:not([style*="display: none"])'
  ).length;
  const totalTeams =
  container.querySelectorAll(
  ".team-item"
  ).length;
  const countElement =
  container.querySelector(
  ".teams-count"
  );
  if (countElement) {
  if (searchTerm) {
  countElement.textContent = `(${visibleTeams} of ${totalTeams} teams match)`;
  countElement.style.display =
  "inline";
  } else {
  countElement.textContent =
  "";
  }
  }
  }
  );
  }}
  />
  </div>
  </div>
  {isLoading ? (
  <div className="flex items-center justify-center py-4">
  <div className="w-5 h-5 mr-2 border-b-2 border-blue-700 rounded-full animate-spin"></div>
  <p
  className="text-sm text-[#555555]"
  >
  Loading teams...
  </p>
  </div>
  ) : sportTeams.length === 0 ? (
  <div
  className="py-4 text-center text-[#555555]"
  >
  <UserCheck className="w-8 h-8 mx-auto mb-2 text-[#999999]" />
  <p>
  No teams available for this sport.
  </p>
  </div>
  ) : (
  <>
  <div className="flex items-center justify-between py-3 mb-3">
  <p
  className="ml-2 text-xs font-medium text-[#999999]"
  >
  Teams ({sportTeams.length}):
  </p>
  {selectedTeamsCount > 0 && (
  <div
  className="flex items-center space-x-3 text-sm text-[#555555]"
  >
  <button
  className="flex items-center px-1 space-x-2 text-xs rounded-full shadow-sm text-red-300 bg-red-900/30"
  onClick={() => {
  setTemplateData((prev) => ({
  ...prev,
  permissions:
  prev.permissions.filter(
  (p) =>
  p.sportId !==
  sport.id
  ),
  }));
  }}
  >
  <X size={14} />
  <span>clear all</span>
  </button>
  <p>
  <span>
  {selectedTeamsCount}{" "}
  selected
  </span>
  </p>
  </div>
  )}
  </div>
  <div
  id="edit-teams-container"
  className="flex flex-col gap-2 max-h-[250px] overflow-y-auto"
  >
  {sportTeams.map((team) => (
  <div
  key={team.TeamID}
  className={`flex items-center text-start p-2 rounded-md transition-colors team-item ${
  isPermissionSelected(
  sport.id,
  team.TeamID.toString()
  )
  ? `border bg-[#111111] border-[#1A1A1A]`
  : "hover:bg-[#0A0A0A]"
  }`}
  data-team-name={team.Name}
  >
  <input
  type="checkbox"
  id={`team-${team.TeamID}`}
  className="w-3 h-3 mr-2 text-blue-600 rounded"
  checked={isPermissionSelected(
  sport.id,
  team.TeamID.toString()
  )}
  onChange={() =>
  togglePermission(
  sport.id,
  team.TeamID.toString(),
  mode
  )
  }
  />
  <label
  htmlFor={`team-${team.TeamID}`}
  className="flex-1 ml-4 text-sm cursor-pointer text-[#999999]"
  >
  {team.Name}
  </label>
  </div>
  ))}
  </div>
  </>
  )}
  </div>
  )}
  </div>
  );
  })}
  </div>
  )}
  </div>
  </div>
  </div>
  </div>
  </div>
  </div>

  {/* Footer with action buttons */}
  <div
  className="px-6 py-4 border-t rounded-b-xl bg-[#111111] border-[#1A1A1A]"
  >
  <div className="flex items-center justify-end">
  <div className="flex space-x-3">
  <button
  type="button"
  onClick={onClose}
  className="px-6 py-2 text-sm font-medium transition-colors border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E8B800] text-[#999999] bg-[#0A0A0A] border-[#1A1A1A] hover:bg-[#111111]"
  disabled={isSubmitting}
  >
  Cancel
  </button>
  <button
  type="button"
  onClick={() => onSubmit(templateData?.id)}
  disabled={isSubmitting || !templateData.name}
  className={`px-6 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-black transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${
  isSubmitting || !templateData.name
  ? "cursor-not-allowed bg-[#E8B800]/70"
  : "bg-gradient-to-r from-[#E8B800] to-[#D4A800] hover:from-[#D4A800] hover:to-[#C49B00] focus:ring-[#E8B800]"
  }`}
  >
  {isSubmitting ? (
  <span className="flex items-center">
  <div className="w-4 h-4 mr-2 border-b-2 border-[#F5F5F5] rounded-full animate-spin"></div>
  {mode === "add" ? "Creating..." : "Updating..."}
  </span>
  ) : mode === "add" ? (
  "Create Template"
  ) : (
  "Update Template"
  )}
  </button>
  </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  );
};

const Permissions = () => {
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("users");
  const [templatesView, setTemplatesView] = useState("list"); // 'list', 'create', or 'details'
  const [sportsView, setSportsView] = useState("list"); // 'list', 'create', or 'edit'
  const [editingSport, setEditingSport] = useState(null);

  // newly added stats
  // *******************from here *********************
  const [activeFilterTab, setActiveFilterTab] = useState("all");
  const [userRoleFilter, setUserRoleFilter] = useState("all");
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [mode, setMode] = useState("add"); // 'add' or 'edit'
  const [templateData, setTemplateData] = useState({
  name: "",
  description: "",
  roleType: "", // Role type for this template (e.g., HEAD_COACH, ANALYST_SCOUT)
  permissions: [],
  });
  const [isSportModalOpen, setIsSportModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // *******************to here *********************

  // User role and status editing
  const [editingUser, setEditingUser] = useState(null);
  const [updatingUser, setUpdatingUser] = useState(false);
  const [userUpdateError, setUserUpdateError] = useState(null);
  const [userUpdateSuccess, setUserUpdateSuccess] = useState(null);

  // User permission template assignment state
  const [selectedUser, setSelectedUser] = useState(null);
  const [editingUserTemplates, setEditingUserTemplates] = useState(false);
  const [selectedTemplateIds, setSelectedTemplateIds] = useState([]);
  const [updatingUserTemplates, setUpdatingUserTemplates] = useState(false);
  const [userTemplateError, setUserTemplateError] = useState(null);

  // Sports state
  const [sports, setSports] = useState([]);
  const [enabledSports, setEnabledSports] = useState([]);
  const [loadingSports, setLoadingSports] = useState(false);
  const [loadingEnabledSports, setLoadingEnabledSports] = useState(false);
  const [sportError, setSportError] = useState(null);
  const [newSport, setNewSport] = useState({
  name: "",
  code: "",
  isEnable: true,
  });

  // Teams state
  const [teamsData, setTeamsData] = useState({});
  const [loadingTeams, setLoadingTeams] = useState(false);

  // Expanded sports for the selection UI
  const [expandedSports, setExpandedSports] = useState([]);
  const [isSportExpanded, setIsSportExpanded] = useState(false);

  // Templates state - all data comes from API, no static data
  const [permissionTemplates, setPermissionTemplates] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [templateError, setTemplateError] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [loadingTemplateDetails, setLoadingTemplateDetails] = useState(false);
  const [isEditingTemplate, setIsEditingTemplate] = useState(false);
  const [updatingTemplate, setUpdatingTemplate] = useState(false);
  const [editingTemplateData, setEditingTemplateData] = useState({
  name: "",
  id: null,
  description: "",
  roleType: "", // Role type for this template
  permissions: [],
  });

  // New template form state
  const [newTemplate, setNewTemplate] = useState({
  name: "",
  description: "",
  roleType: "", // Role type for this template
  sports: [],
  teams: [],
  permissions: [], // Add routes selection
  });

  // Template creation state
  const [creatingTemplate, setCreatingTemplate] = useState(false);

  // Define available admin routes
  const adminRoutes = [
  {
  path: "/dashboard",
  name: "Dashboard",
  description: "Access to dashboard and how it works page",
  },
  {
  path: "/my-dashboard",
  name: "My Dashboard",
  description: "Access to personal dashboard",
  },
  {
  path: "/chat",
  name: "Chat with diSearch",
  description: "Access to chat functionality",
  },
  {
  path: "/player-roster",
  name: "Player Roster",
  description: "Access to player roster management",
  },
  {
  path: "/player-profile",
  name: "My Teams",
  description: "Access to My Teams",
  },
  {
  path: "/scouting",
  name: "Scouting",
  description: "Access to scouting and matching tools",
  },
  {
  path: "/pre-college-player",
  name: "PreCollege Players",
  description: "Access to PreCollege Players Portal",
  },
  {
  path: "/video-analytics",
  name: "Video Analytics",
  description: "Access to video analytics tools",
  },
  {
  path: "/synergy-video",
  name: "Synergy Video",
  description: "Access to video and csv analytics tools",
  },
  {
  path: "/development",
  name: "Development",
  description: "Access to development features",
  },
  {
  path: "/reports",
  name: "Reports",
  description: "Access to reports generation",
  },
  {
  path: "/settings",
  name: "Settings",
  description: "Access to system settings",
  },
  {
  path: "/integrations",
  name: "Integrations",
  description: "Access to integrations management",
  },
  ];

  // Update an existing template
  const updateTemplate = async (templateId) => {
  if (!templateId) return;

  setUpdatingTemplate(true);
  setTemplateError(null);

  try {
  // Prepare the request payload
  const payload = {
  name: editingTemplateData.name,
  description: editingTemplateData.description,
  permissions: editingTemplateData.permissions,
  };

  // Make the API call
  const response = await axios.put(
  `${NODE_BACKEND_URL}/api/permission-templates/${templateId}`,
  payload,
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );

  if (response.data && response.data.success) {
  // Update the selected template with the new data
  setSelectedTemplate({
  ...response.data.template,
  permissions: response.data.permissions || [],
  });
  setIsTemplateModalOpen(false);

  // Refresh the templates list
  fetchTemplates();

  // Exit edit mode
  setIsEditingTemplate(false);
  } else {
  setTemplateError(
  "Failed to update template. " +
  (response.data.message || "Please try again.")
  );
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error updating template:", error);
  setTemplateError("Failed to update template. Server error.");
  } finally {
  setUpdatingTemplate(false);
  }
  };

  // Toggle sport expansion
  const toggleSportExpansion = (sportId) => {
  const isCurrentlyExpanded = expandedSports.includes(sportId);
  let teams;

  setIsSportExpanded((prev) => !prev);

  // If we're expanding the sport, fetch its teams if we haven't already
  if (!isCurrentlyExpanded) {
  const sport =
  sports.find((s) => s.id === sportId) ||
  enabledSports.find((s) => s.id === sportId);
  if (
  sport &&
  sport.code &&
  (!teamsData[sport.code] || teamsData[sport.code].length === 0)
  ) {
  teams = fetchTeamsForSport(sport.code);
  }
  }

  setExpandedSports((prevExpanded) =>
  isCurrentlyExpanded
  ? prevExpanded.filter((id) => id !== sportId)
  : [...prevExpanded, sportId]
  );
  return teams;
  };

  // handle sports toggle
  const handleSportCheckBox = (sportId) => {
  const isCurrentlyExpanded = expandedSports.includes(sportId);
  let teams;

  setIsSportExpanded((prev) => !prev);

  // If we're expanding the sport, fetch its teams if we haven't already
  if (!isCurrentlyExpanded) {
  const sport =
  sports.find((s) => s.id === sportId) ||
  enabledSports.find((s) => s.id === sportId);
  if (
  sport &&
  sport.code &&
  (!teamsData[sport.code] || teamsData[sport.code].length === 0)
  ) {
  teams = fetchTeamsForSport(sport.code);
  }
  }

  setExpandedSports((prevExpanded) =>
  isCurrentlyExpanded
  ? prevExpanded
  : // .filter((id) => id !== sportId)
  [...prevExpanded, sportId]
  );
  return teams;
  };

  // Fetch all templates
  const fetchTemplates = async () => {
  setLoadingTemplates(true);
  setTemplateError(null);

  try {
  const response = await axios.get(
  `${NODE_BACKEND_URL}/api/template-permissions`,
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );

  if (
  response.data &&
  response.data.success &&
  Array.isArray(response.data.templates)
  ) {
  setPermissionTemplates(response.data.templates);
  } else {
  console.error("Invalid response format for templates:", response.data);
  setTemplateError("Failed to load templates. Invalid response format.");
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error fetching templates:", error);
  setTemplateError("Failed to load templates. Server error.");
  } finally {
  setLoadingTemplates(false);
  }
  };

  // Fetch a single template's details
  const fetchTemplateDetailsForEdit = async (templateId) => {
  if (!templateId) return;
  fetchSports();
  setMode("edit");
  setLoadingTemplateDetails(true);
  setTemplateError(null);
  setIsEditingTemplate(true);

  try {
  const response = await axios.get(
  `${NODE_BACKEND_URL}/api/permission-templates/${templateId}`,
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );

  if (response.data && response.data.success && response.data.template) {
  const templateData = {
  ...response.data.template,
  permissions: response.data.permissions || [],
  };

  setSelectedTemplate(templateData);
  setEditingTemplateData({
  id: templateData?.id,
  name: templateData.name,
  description: templateData.description,
  permissions: templateData.permissions.map((p) => ({
  sportId: p.sportId,
  teamId: p.teamId,
  routePath: p.routePath || p.routePath,
  })),
  });

  setIsTemplateModalOpen(true);
  } else {
  console.error(
  "Invalid response format for template details:",
  response.data
  );
  setTemplateError(
  "Failed to load template details. Invalid response format."
  );
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error fetching template details:", error);
  setTemplateError("Failed to load template details. Server error.");
  } finally {
  setLoadingTemplateDetails(false);
  }
  };

  // Fetch teams from API
  const fetchTeamsForSport = async (sportCode) => {
  if (!sportCode) return;

  setLoadingTeams(true);
  try {
  console.log(`Fetching teams for sport code: ${sportCode}`);
  const response = await axios.get(
  `${NODE_BACKEND_URL}/api/teams/${sportCode}`,
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );

  if (
  response.data &&
  response.data.success &&
  Array.isArray(response.data.teams)
  ) {
  const teams = response.data.teams;
  setTeamsData((prevTeams) => ({
  ...prevTeams,
  [sportCode]: teams,
  }));
  return teams;
  } else {
  console.error("Invalid response format for teams:", response.data);
  return [];
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error(`Error fetching teams for sport ${sportCode}:`, error);
  // Set empty array for this sport code to prevent repeated failed requests
  setTeamsData((prevTeams) => ({
  ...prevTeams,
  [sportCode]: [],
  }));
  return [];
  } finally {
  setLoadingTeams(false);
  }
  };

  // Fetch sports from API
  const fetchSports = async () => {
  setLoadingSports(true);
  setSportError(null);
  try {
  const response = await axios.get(`${NODE_BACKEND_URL}/api/sports`, {
  headers: {
  Authorization: getAuthToken(),
  },
  });
  if (response.data && response.data.success) {
  const fetchedSports = response.data.sports;
  setSports(fetchedSports);

  // We'll fetch teams on demand when a sport is expanded instead of fetching all at once
  } else {
  console.error("Invalid response format:", response.data);
  setSportError("Failed to load sports. Please try again.");
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error fetching sports:", error);
  setSportError("Failed to load sports. Server error.");
  } finally {
  setLoadingSports(false);
  }
  };

  // Create a new sport
  const createSport = async () => {
  if (!newSport.name || !newSport.code) {
  setSportError("Name and code are required fields.");
  return;
  }

  setLoadingSports(true);
  setSportError(null);
  try {
  const response = await axios.post(
  `${NODE_BACKEND_URL}/api/sports`,
  newSport,
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );
  if (response.data && response.data.success) {
  const createdSport = response.data.sport;
  setSports([...sports, createdSport]);

  // Fetch teams for the new sport
  if (createdSport.code) {
  await fetchTeamsForSport(createdSport.code);
  }

  setNewSport({ name: "", code: "", isEnable: true });
  setIsSportModalOpen(false);
  } else {
  setIsSportModalOpen(false);
  setSportError("Failed to create sport. Please try again.");
  }
  } catch (error) {
  setIsSportModalOpen(false);
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error creating sport:", error);
  setSportError("Failed to create sport. Server error.");
  } finally {
  setLoadingSports(false);
  }
  };

  // Update an existing sport
  const updateSport = async () => {
  if (!editingSport || !editingSport.id) {
  setSportError("Invalid sport data.");
  return;
  }

  if (!editingSport.name || !editingSport.code) {
  setSportError("Name and code are required fields.");
  return;
  }

  setLoadingSports(true);
  setSportError(null);
  try {
  const response = await axios.put(
  `${NODE_BACKEND_URL}/api/sports/${editingSport.id}`,
  {
  name: editingSport.name,
  code: editingSport.code,
  isEnable: editingSport.isEnable,
  },
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );

  if (response.data && response.data.success) {
  const updatedSport = response.data.sport;
  setSports(
  sports.map((sport) =>
  sport.id === editingSport.id ? { ...sport, ...updatedSport } : sport
  )
  );

  // If code was changed, fetch teams with new code
  if (updatedSport.code !== editingSport.code) {
  await fetchTeamsForSport(updatedSport.code);
  }

  setEditingSport(null);
  setIsSportModalOpen(false);
  } else {
  setIsSportModalOpen(false);
  setSportError("Failed to update sport. Please try again.");
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error updating sport:", error);
  setSportError("Failed to update sport. Server error.");
  } finally {
  setLoadingSports(false);
  }
  };

  // Delete a sport
  const deleteSport = async (id) => {
  if (!window.confirm("Are you sure you want to delete this sport?")) {
  return;
  }

  setLoadingSports(true);
  setSportError(null);
  try {
  const response = await axios.delete(
  `${NODE_BACKEND_URL}/api/sports/${id}`,
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );
  if (response.data && response.data.success) {
  setSports(sports.filter((sport) => sport.id !== id));
  } else {
  setSportError("Failed to delete sport. Please try again.");
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error deleting sport:", error);
  setSportError("Failed to delete sport. Server error.");
  } finally {
  setLoadingSports(false);
  }
  };

  // Fetch only enabled sports for templates
  const fetchEnabledSports = async () => {
  setLoadingEnabledSports(true);
  try {
  const response = await axios.get(
  `${NODE_BACKEND_URL}/api/sports?enabledOnly=true`,
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );
  if (response.data && response.data.success) {
  const fetchedSports = response.data.sports;
  setEnabledSports(fetchedSports);

  // We'll fetch teams on demand when a sport is expanded instead of fetching all at once
  } else {
  console.error("Invalid response format:", response.data);
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error fetching enabled sports:", error);
  } finally {
  setLoadingEnabledSports(false);
  }
  };

  // Effect to fetch templates when the templates tab is opened
  useEffect(() => {
  if (activeTab === "templates" && templatesView === "list") {
  fetchTemplates();
  }
  }, [activeTab, templatesView]);

  // Effect to fetch enabled sports when templates view is opened
  useEffect(() => {
  if (activeTab === "templates" && templatesView === "create") {
  fetchEnabledSports();
  }
  }, [activeTab, templatesView]);

  useEffect(() => {
  if (activeTab === "users") {
  fetchUsers();
  } else if (activeTab === "sports") {
  fetchSports();
  }
  }, [activeTab]);

  const fetchUsers = async () => {
  setLoadingUsers(true);
  setUserUpdateError(null);
  setUserUpdateSuccess(null);
  try {
  const response = await axios.get(`${NODE_BACKEND_URL}/api/users`, {
  headers: {
  Authorization: getAuthToken(),
  },
  });
  if (
  response.data &&
  response.data.success &&
  Array.isArray(response.data.users)
  ) {
  setUsers(response.data.users);
  } else {
  console.error("Invalid response format:", response.data);
  }
  } catch (error) {
  console.log("ERROR =>", error);
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error fetching users:", error);
  } finally {
  setLoadingUsers(false);
  }
  };

  // Function to update user role and/or approval status
  const updateUserStatus = async (userId, updates) => {
  if (!userId || (!updates.role && updates.isApproved === undefined)) {
  setUserUpdateError("No valid updates provided");
  return;
  }

  setUpdatingUser(true);
  setUserUpdateError(null);
  setUserUpdateSuccess(null);

  try {
  const response = await axios.put(
  `${NODE_BACKEND_URL}/api/users/${userId}/update-status`,
  updates,
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );

  if (response.data && response.data.success) {
  // Update the user in local state
  setUsers((prevUsers) =>
  prevUsers.map((user) =>
  user.id === userId ? { ...user, ...response.data.user } : user
  )
  );
  setUserUpdateSuccess("User status updated successfully");
  // Reset editing state
  setEditingUser(null);
  } else {
  setUserUpdateError(
  response.data?.message || "Failed to update user status"
  );
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error updating user status:", error);
  setUserUpdateError(
  error.response?.data?.message ||
  "Server error while updating user status"
  );
  } finally {
  setUpdatingUser(false);
  }
  };

  // Function to save both role and status at once when editing
  const saveUserChanges = () => {
  if (
  selectedUser?.permissionTemplates?.length !== selectedTemplateIds?.length
  ) {
  saveUserTemplates();
  }

  if (!editingUser) return;

  const updates = {};
  if (
  editingUser.newRole !== undefined &&
  editingUser.newRole !== editingUser.originalRole
  ) {
  updates.role = editingUser.newRole;
  }
  if (
  editingUser.newApproval !== undefined &&
  editingUser.newApproval !== editingUser.originalApproval
  ) {
  updates.isApproved = editingUser.newApproval;
  }

  // if(editingUser.template)
  if (Object.keys(updates).length === 0) {
  setEditingUser(null);
  return;
  }

  updateUserStatus(editingUser.id, updates);
  };

  // Function to start editing a user's status
  const startEditingUser = (user) => {
  setEditingUserTemplates(true);
  fetchTemplates();
  openTemplateAssignment(user);
  setEditingUser({
  id: user.id,
  originalRole: user.role,
  originalApproval: user.isApproved,
  newRole: user.role,
  newApproval: user.isApproved,
  });
  };

  // Function to cancel editing
  const cancelEditingUser = () => {
  setEditingUser(null);
  };

  let filteredUsers;
  let filteredTemplates;
  let filteredSports;

  // 1. Search function
  const filterBySearch = (items, searchTerm) => {
  return items.filter(
  (item) =>
  item?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  (item?.email &&
  item.email.toLowerCase().includes(searchTerm.toLowerCase()))
  );
  };

  if (activeTab === "users") {
  // 2. Filter by role function
  const filterByRole = (items, role) => {
  if (role === "all") return items;
  return items.filter(
  (item) => item?.role && item.role.toLowerCase() === role.toLowerCase()
  );
  };

  // 3. Filter by status function
  const filterByStatus = (items, status) => {
  if (status === "all") return items;
  if (status === "approved")
  return items.filter((item) => item.isApproved === true);
  if (status === "rejected")
  return items.filter((item) => item.isApproved === false);
  return items;
  };

  filteredUsers = users;
  filteredUsers = filterBySearch(filteredUsers, searchTerm);
  filteredUsers = filterByStatus(filteredUsers, activeFilterTab);
  filteredUsers = filterByRole(filteredUsers, userRoleFilter);
  }

  if (activeTab === "templates") {
  filteredTemplates = permissionTemplates;
  filteredTemplates = filterBySearch(filteredTemplates, searchTerm);
  }

  if (activeTab === "sports") {
  // 3. Filter by status function
  const filterSportsByStatus = (items, status) => {
  if (status === "all") return items;
  if (status === "active")
  return items.filter((item) => item.isEnable === true);
  if (status === "inactive")
  return items.filter((item) => item.isEnable === false);
  return items;
  };

  filteredSports = sports;
  filteredSports = filterBySearch(filteredSports, searchTerm);
  filteredSports = filterSportsByStatus(filteredSports, activeFilterTab);
  }

  // Function to open the template assignment modal
  const openTemplateAssignment = (user) => {
  setSelectedUser(user);
  setSelectedTemplateIds(
  user.permissionTemplates
  ? user.permissionTemplates.map((template) => template.templateId)
  : []
  );
  setEditingUserTemplates(true);
  setUserTemplateError(null);

  // Make sure templates are loaded
  if (permissionTemplates.length === 0) {
  fetchTemplates();
  }
  };

  // Function to close the template assignment modal
  const closeTemplateAssignment = () => {
  setSelectedUser(null);
  setEditingUserTemplates(false);
  setSelectedTemplateIds([]);
  };

  // Function to toggle template selection for a user
  const toggleTemplateSelection = (templateId) => {
  setSelectedTemplateIds((prev) =>
  prev.includes(templateId)
  ? prev.filter((id) => id !== templateId)
  : [...prev, templateId]
  );
  };

  // Function to save user permission templates
  const saveUserTemplates = async () => {
  if (!selectedUser) return;

  setUpdatingUserTemplates(true);
  setUserTemplateError(null);

  try {
  const payload = {
  userId: selectedUser.id,
  templateIds: selectedTemplateIds,
  };

  const response = await axios.post(
  `${NODE_BACKEND_URL}/api/permission-templates/user-access`,
  payload,
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );

  if (response.data && response.data.success) {
  successMessage("User Updated successfully");
  // Update the user in the local state
  setUsers((prevUsers) =>
  prevUsers.map((user) => {
  if (user.id === selectedUser.id) {
  // Create updated user with new template assignments
  const updatedPermissionTemplates = selectedTemplateIds
  .map((templateId) => {
  const template = permissionTemplates.find(
  (t) => t.id === templateId
  );
  return template
  ? {
  templateId: template.id,
  templateName: template.name,
  templateDescription: template.description,
  }
  : null;
  })
  .filter(Boolean);

  return {
  ...user,
  permissionTemplates: updatedPermissionTemplates,
  };
  }
  return user;
  })
  );

  // Close the modal
  closeTemplateAssignment();
  } else {
  setUserTemplateError(
  "Failed to update user templates. " +
  (response.data.message || "Please try again.")
  );
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error updating user templates:", error);
  setUserTemplateError("Failed to update user templates. Server error.");
  } finally {
  setUpdatingUserTemplates(false);
  }
  };

  // Handle create template
  const handleCreateTemplate = async () => {
  if (!newTemplate.name) {
  setTemplateError("Template name is required.");
  return;
  }

  setCreatingTemplate(true);
  setTemplateError(null);

  try {
  // Format the permissions array from selected sports, teams, and routes
  const permissions = [];

  // Add all selected team-sport combinations
  newTemplate.teams.forEach((teamId) => {
  // Find which sport this team belongs to
  for (const sportId of newTemplate.sports) {
  const sport = enabledSports.find((s) => s.id === sportId);
  if (sport && sport.code) {
  const teams = teamsData[sport.code] || [];
  if (teams.some((team) => team.TeamID === teamId)) {
  permissions.push({
  sportId: sportId.toString(),
  teamId: teamId.toString(),
  });
  break; // Found the sport for this team, no need to continue
  }
  }
  }
  });

  // Add selected route permissions
  newTemplate.permissions.forEach((permission) => {
  permissions.push({
  routePath: permission.routePath,
  id: permission.routePath,
  });
  });

  // Prepare the request payload
  const payload = {
  name: newTemplate.name,
  description: newTemplate.description,
  permissions: permissions,
  };

  // Make the API call
  const response = await axios.post(
  `${NODE_BACKEND_URL}/api/permission-templates`,
  payload,
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );

  if (response.data && response.data.success) {
  // Refresh the templates list
  fetchTemplates();

  // Reset the form
  setNewTemplate({
  name: "",
  description: "",
  sports: [],
  teams: [],
  permissions: [],
  });

  // Return to the list view
  setIsTemplateModalOpen(false);
  } else {
  setTemplateError(
  "Failed to create template. " +
  (response.data.message || "Please try again.")
  );
  setIsTemplateModalOpen(false);
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error creating template:", error);
  setTemplateError("Failed to create template. Server error.");
  setIsTemplateModalOpen(false);
  } finally {
  setCreatingTemplate(false);
  }
  };

  // Update an existing template
  const handleUpdateTemplate = async (templateId) => {
  if (!templateId) return;

  setUpdatingTemplate(true);
  setTemplateError(null);
  try {
  // Prepare the request payload

  const payload = {
  name: editingTemplateData.name,
  description: editingTemplateData.description,
  permissions: editingTemplateData.permissions,
  };
  // Make the API call
  const response = await axios.put(
  `${NODE_BACKEND_URL}/api/permission-templates/${templateId}`,
  payload,
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );
  console.log("response ==>", response);
  if (response.data && response.data.success) {
  // Update the selected template with the new data
  setSelectedTemplate({
  ...response.data.template,
  permissions: response.data.permissions || [],
  });

  // Refresh the templates list
  fetchTemplates();

  // Exit edit mode
  setIsEditingTemplate(false);
  setIsTemplateModalOpen(false);
  successMessage("Template updated successfully");
  } else {
  setTemplateError(
  "Failed to update template. " +
  (response.data.message || "Please try again.")
  );
  setIsTemplateModalOpen(false);
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error updating template:", error);
  setTemplateError("Failed to update template. Server error.");
  setIsTemplateModalOpen(false);
  } finally {
  setUpdatingTemplate(false);
  }
  };

  // Toggle permission selection for editing
  const togglePermission = (sportId, teamId, mode) => {
  if (mode === "add") {
  setNewTemplate((prev) => {
  // Look for this exact permission
  const existingIndex = prev.permissions.findIndex(
  (p) => p.sportId === sportId && p.teamId === teamId
  );

  if (existingIndex >= 0) {
  // Remove this permission
  return {
  ...prev,
  permissions: prev.permissions.filter(
  (_, index) => index !== existingIndex
  ),
  };
  } else {
  // Add this permission
  return {
  ...prev,
  permissions: [...prev.permissions, { sportId, teamId }],
  };
  }
  });
  } else {
  setEditingTemplateData((prev) => {
  // Look for this exact permission
  const existingIndex = prev.permissions.findIndex(
  (p) => p.sportId === sportId && p.teamId === teamId
  );

  if (existingIndex >= 0) {
  // Remove this permission
  return {
  ...prev,
  permissions: prev.permissions.filter(
  (_, index) => index !== existingIndex
  ),
  };
  } else {
  // Add this permission
  return {
  ...prev,
  permissions: [...prev.permissions, { sportId, teamId }],
  };
  }
  });
  }
  };

  // Toggle route permission
  const toggleRoutePermission = (routePath) => {
  setEditingTemplateData((prev) => {
  // Look for this exact route permission
  const existingIndex = prev.permissions.findIndex(
  (p) => p.routePath === routePath
  );

  if (existingIndex >= 0) {
  // Remove this permission
  return {
  ...prev,
  permissions: prev.permissions.filter(
  (_, index) => index !== existingIndex
  ),
  };
  } else {
  // Add this permission
  return {
  ...prev,
  permissions: [...prev.permissions, { routePath }],
  };
  }
  });
  };

  // Check if a permission is selected in edit mode
  const isPermissionSelected = (sportId, teamId) => {
  return (
  editingTemplateData.permissions.some(
  (p) => p.sportId === sportId && p.teamId === teamId
  ) ||
  newTemplate.permissions.some(
  (p) => p.sportId === sportId && p.teamId === teamId
  )
  );
  };

  // Check if a route permission is selected in edit mode
  const isRoutePermissionSelected = (routePath) => {
  return editingTemplateData.permissions.some(
  (p) => p.routePath === routePath
  );
  };

  // // Delete a template
  const deleteTemplate = async (templateId) => {
  if (
  !window.confirm(
  "Are you sure you want to delete this template? This action cannot be undone."
  )
  ) {
  return;
  }

  setTemplateError(null);

  try {
  const response = await axios.delete(
  `${NODE_BACKEND_URL}/api/permission-templates/${templateId}`,
  {
  headers: {
  Authorization: getAuthToken(),
  },
  }
  );

  if (response.data && response.data.success) {
  // If viewing the template being deleted, go back to list
  if (selectedTemplate && selectedTemplate.id === templateId) {
  setTemplatesView("list");
  setSelectedTemplate(null);
  }

  // Refresh the templates list
  fetchTemplates();
  } else {
  setTemplateError(
  "Failed to delete template. " +
  (response.data.message || "Please try again.")
  );
  }
  } catch (error) {
  if (!error?.response && error?.code === "ERR_NETWORK") {
  goToLogin(); // ✅ Redirect to login on network error
  }
  console.error("Error deleting template:", error);
  setTemplateError("Failed to delete template. Server error.");
  }
  };

  // Prepare to edit a template - fetch all sports and teams first
  const prepareEditTemplate = () => {
  // First make sure we have all sports and teams available
  if (sports.length === 0) {
  fetchSports();
  }

  // For each sport, make sure we have its teams
  for (const sport of sports) {
  if (
  sport.code &&
  (!teamsData[sport.code] || teamsData[sport.code].length === 0)
  ) {
  fetchTeamsForSport(sport.code);
  }
  }

  setIsEditingTemplate(true);
  };

  // When opening modal for add
  const openAddTemplateModal = () => {
  setMode("add");
  fetchSports();
  setTemplateData({
  name: "",
  description: "",
  permissions: [],
  sports: [],
  teams: [],
  });
  setIsTemplateModalOpen(true);
  };

  return (
  <div
  className="page-container bg-[#0a0a0a]"
  >
  <div className="px-4 py-6 mx-auto max-w-7xl sm:px-6 lg:px-8 scrollable-content">
  {/* Modern Header */}
  <div className="mb-8">
  <div className="flex flex-col md:flex-row md:items-center md:justify-between">
  <div className="mb-4 md:mb-0">
  <div className="flex items-center space-x-3">
  <div className="text-left">
  <h1
  className="text-3xl font-bold text-left text-[#999999]"
  >
  Permissions
  </h1>
  <p
  className="mt-1 text-left text-[#555555]"
  >
  Manage system access and user roles
  </p>
  </div>
  </div>
  </div>
  </div>
  </div>

  {/* Modern Tab Navigation */}
  <div className="mb-8">
  <div
  className="border-b  border-[#1A1A1A]"
  >
  <nav className="flex space-x-1" aria-label="Tabs">
  <button
  onClick={() => {
  setActiveTab("users");
  setActiveFilterTab("all");
  setUserRoleFilter("all");
  }}
  className={`flex items-center  justify-center px-3 py-2 text-sm font-medium rounded-t-md transition-all duration-200 ${
  activeTab === "users"
  ? "bg-[#E8B800] text-black"
  : `text-[#555555] hover:text-[#999999] hover:bg-[#0A0A0A]`
  }`}
  >
  Users
  </button>
  <button
  onClick={() => {
  setActiveTab("templates");
  setTemplatesView("list");
  setActiveFilterTab("all");
  setUserRoleFilter("all");
  }}
  className={`flex items-center justify-center px-3 py-2 text-sm font-medium rounded-t-md transition-all duration-200 ${
  activeTab === "templates"
  ? "bg-[#E8B800] text-black"
  : `text-[#555555] hover:text-[#999999] hover:bg-[#0A0A0A]`
  }`}
  >
  Templates
  </button>
  <button
  onClick={() => {
  setActiveTab("sports");
  setSportsView("list");
  setActiveFilterTab("all");
  setUserRoleFilter("all");
  }}
  className={`flex items-center  justify-center px-3 py-2 text-sm font-medium rounded-t-md transition-all duration-200 ${
  activeTab === "sports"
  ? "bg-[#E8B800] text-black"
  : `text-[#555555] hover:text-[#999999] hover:bg-[#0A0A0A]`
  }`}
  >
  Sports
  </button>
  </nav>
  </div>
  </div>

  {/* Users Tab Content */}
  {activeTab === "users" && (
  <div className="space-y-6">
  {/* Search and Filters */}
  <div
  className="p-6 bg-[#111111] border border-[#1A1A1A] shadow-sm rounded-[14px]"
  >
  <div className="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
  <div className="flex-1 max-w-md">
  <div className="relative">
  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
  <Search
  className="w-5 h-5 text-[#999999]"
  />
  </div>
  <input
  type="search"
  className="block w-full py-2 pl-10 pr-3 text-sm transition-colors border rounded-lg focus:outline-none text-[#999999] border-[#1A1A1A] focus:border-[#E8B800] bg-[#0A0A0A] placeholder-[#555555]"
  placeholder="Search users by name or email..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  />
  </div>
  </div>

  <div
  className="flex items-center space-x-4 text-sm text-[#F5F5F5]"
  >
  <CustomSelect
  options={[
  { value: "all", label: "All Roles" },
  { value: "admin", label: "Admin" },
  { value: "user", label: "User" },
  ]}
  value={userRoleFilter}
  onChange={setUserRoleFilter}
  classes="w-28 relative"
  />

  {/* ALL STATUS */}
  <button
  className={`${
  activeFilterTab === "all"
  ? "bg-[#E8B800] text-black"
  : "bg-[#111111] text-[#999999] hover:bg-[#E8B800] hover:text-black"
  } flex items-center rounded-full px-2 py-1 transition`}
  onClick={() => setActiveFilterTab("all")}
  >
  <div
  className="w-2 h-2 mr-2 rounded-full bg-[#555555]"
  ></div>
  All Status
  </button>

  {/* APPROVED */}
  <button
  className={`${
  activeFilterTab === "approved"
  ? "bg-[#E8B800] text-black"
  : "bg-[#111111] text-[#999999] hover:bg-[#E8B800] hover:text-black"
  } flex items-center rounded-full px-2 py-1 transition`}
  onClick={() => setActiveFilterTab("approved")}
  >
  <div
  className="w-2 h-2 mr-2 rounded-full bg-[#555555]"
  ></div>
  Approved
  </button>

  {/* REJECTED */}
  <button
  className={`${
  activeFilterTab === "rejected"
  ? "bg-[#E8B800] text-black"
  : "bg-[#111111] text-[#999999] hover:bg-[#E8B800] hover:text-black"
  } flex items-center rounded-full px-2 py-1 transition`}
  onClick={() => setActiveFilterTab("rejected")}
  >
  <div
  className="w-2 h-2 mr-2 rounded-full bg-[#333333]"
  ></div>
  Rejected
  </button>
  </div>
  </div>
  </div>

  {/* Alert Messages */}
  {userUpdateError && (
  <div
  className="px-4 py-3 border rounded-lg shadow-sm bg-red-900/40 border-red-800 text-red-300"
  >
  <div className="flex items-center">
  <AlertCircle className="flex-shrink-0 w-5 h-5 mr-2" />
  <span>{userUpdateError}</span>
  </div>
  </div>
  )}

  {userUpdateSuccess && (
  <div
  className="px-4 py-3 border rounded-lg shadow-sm bg-green-900/40 border-green-800 text-green-300"
  >
  <div className="flex items-center">
  <Shield className="flex-shrink-0 w-5 h-5 mr-2" />
  <span>{userUpdateSuccess}</span>
  </div>
  </div>
  )}

  {/* Users Content */}
  {loadingUsers ? (
  <div
  className="p-12 border shadow-sm rounded-[14px] bg-[#0A0A0A] border-[#1A1A1A]"
  >
  <div className="text-center">
  <div className="w-12 h-12 mx-auto border-b-2 border-blue-600 rounded-full animate-spin"></div>
  <p
  className="mt-4 text-[#999999]"
  >
  Loading users...
  </p>
  </div>
  </div>
  ) : filteredUsers.length === 0 ? (
  <div
  className="p-12 border shadow-sm rounded-[14px] bg-[#0A0A0A] border-[#1A1A1A]"
  >
  <div className="text-center">
  <UserCheck
  className="w-12 h-12 mx-auto mb-4 text-[#555555]"
  />
  <p
  className="text-lg text-[#555555]"
  >
  {searchTerm
  ? "No users match your search criteria."
  : "No users found."}
  </p>
  {searchTerm && (
  <button
  onClick={() => setSearchTerm("")}
  className="mt-4 font-medium text-[#E8B800] hover:text-[#E8B800]"
  >
  Clear search
  </button>
  )}
  </div>
  </div>
  ) : (
  <div
  className="overflow-hidden border shadow-sm rounded-[14px] bg-[#0A0A0A] border-[#1A1A1A]"
  >
  <div className="overflow-x-auto">
  <table
  className="min-w-full divide-y divide-[#1A1A1A]"
  >
  <thead
  className="bg-[#111111]"
  >
  <tr>
  {["User", "Role", "Status", "Actions"].map(
  (heading) => (
  <th
  key={heading}
  scope="col"
  className="px-4 py-3 text-xs font-medium tracking-wider text-left uppercase text-[#999999]"
  >
  {heading}
  </th>
  )
  )}
  </tr>
  </thead>
  <tbody
  className="bg-[#0A0A0A] divide-[#1A1A1A]"
  >
  {filteredUsers.map((user) => (
  <tr
  key={user.id}
  className="transition-colors hover:bg-[#111111]"
  >
  <td className="px-4 py-3 text-left">
  <div className="flex items-center space-x-3">
  <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-br from-[#E8B800] to-[#D4A800]">
  <span className="text-sm font-medium text-[#F5F5F5]">
  {user.name.charAt(0).toUpperCase()}
  </span>
  </div>
  <div className="flex-1 min-w-0 text-left">
  <p
  className="text-sm font-medium truncate text-[#F5F5F5]"
  >
  {user.name}
  </p>
  <p
  className="text-xs truncate text-[#555555]"
  >
  {user.email}
  </p>
  </div>
  </div>
  </td>

  <td className="px-4 py-3 text-left">
  <span
  className="text-xs font-medium text-[#555555]"
  >
  {user.role || "None"}
  </span>
  </td>

  <td className="px-4 py-3 text-left">
  <span
  className={`px-2 py-1 text-xs font-medium rounded-full ${
  user.isApproved === true
  ? "bg-[#E8B800]/20 text-[#E8B800]"
  : "bg-[#111111] text-[#999999]"
  }`}
  >
  {user.isApproved === true
  ? "Approved"
  : user.isApproved === false
  ? "Rejected"
  : "Pending"}
  </span>
  </td>

  <td className="px-4 py-3 text-left">
  <div className="flex items-center space-x-2">
  <button
  onClick={() => startEditingUser(user)}
  className="p-1.5 rounded-md transition-colors text-[#555555] hover:text-[#F5F5F5] hover:bg-[#111111]"
  title="Edit user"
  >
  <Edit size={14} />
  </button>
  <button
  onClick={() => startEditingUser(user)}
  className="p-1.5 rounded-md transition-colors text-[#555555] hover:text-red-400 hover:bg-[#111111]"
  title="Delete user"
  >
  <Trash2 strokeWidth={3} size={14} />
  </button>
  </div>
  </td>
  </tr>
  ))}
  </tbody>
  </table>
  </div>
  </div>
  )}

  {/* Summary Footer */}
  {!loadingUsers && filteredUsers.length > 0 && (
  <div
  className="p-4 border shadow-sm rounded-[14px] bg-[#0A0A0A] border-[#1A1A1A]"
  >
  <div
  className="flex items-center justify-between text-sm text-[#555555]"
  >
  <span>
  Showing {filteredUsers.length} of {users.length} users
  </span>
  <div className="flex items-center space-x-4">
  <span>
  {users.filter((u) => u.role === "ADMIN").length} Admins
  </span>
  <span>
  {users.filter((u) => u.role === "USER").length} Users
  </span>
  </div>
  </div>
  </div>
  )}
  </div>
  )}

  {/* Templates Tab - List View */}
  {activeTab === "templates" && templatesView === "list" && (
  <div className="space-y-6">
  {/* Search + Actions */}
  <div
  className="p-6 border shadow-sm rounded-[14px] bg-[#0A0A0A] border-[#1A1A1A]"
  >
  <div className="flex flex-col gap-4 space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
  <div className="flex-1 w-full">
  <div className="relative">
  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
  <Search
  className="w-5 h-5 text-[#999999]"
  />
  </div>
  <input
  type="search"
  className="w-full py-2 pl-10 pr-3 text-sm transition-colors border rounded-lg focus:outline-none text-[#999999] border-[#1A1A1A] focus:border-[#E8B800] bg-[#0A0A0A] placeholder-[#555555]"
  placeholder="Search users by name or email..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  />
  </div>
  </div>
  <div
  className="flex items-center space-x-4 text-sm text-[#999999]"
  >
  <button
  onClick={fetchTemplates}
  className="flex items-center px-4 py-2.5 transition-all duration-200 shadow-sm bg-[#111111] text-[#F5F5F5] hover:bg-[rgba(255,255,255,0.06)]"
  >
  <RefreshCw className="w-4 h-4 mr-2" strokeWidth={3} />
  </button>
  <button
  onClick={() => {
  openAddTemplateModal();
  }}
  className="flex items-center px-4 py-2.5 bg-gradient-to-r from-[#E8B800] to-[#D4A800] text-black rounded-lg hover:from-[#D4A800] hover:to-[#C49B00] transition-all duration-200 shadow-lg hover:shadow-xl"
  >
  <Plus className="w-4 h-4 mr-2" />
  Add Template
  </button>
  </div>
  </div>
  </div>

  {/* Error Message */}
  {templateError && (
  <div
  className="px-4 py-3 border rounded-lg shadow-sm bg-red-900/40 border-red-800 text-red-300"
  >
  <div className="flex items-center">
  <AlertCircle className="flex-shrink-0 w-5 h-5 mr-2" />
  <span>{templateError}</span>
  </div>
  </div>
  )}

  {/* Loading State */}
  {loadingTemplates ? (
  <div
  className="p-12 border shadow-sm rounded-[14px] bg-[#0A0A0A] border-[#1A1A1A]"
  >
  <div className="text-center">
  <div className="w-12 h-12 mx-auto border-b-2 border-[#E8B800] rounded-full animate-spin"></div>
  <p
  className="mt-4 text-[#999999]"
  >
  Loading templates...
  </p>
  </div>
  </div>
  ) : filteredTemplates.length === 0 ? (
  <div
  className="p-12 border shadow-sm rounded-[14px] bg-[#0A0A0A] border-[#1A1A1A]"
  >
  <div className="text-center">
  <FileText
  className="w-12 h-12 mx-auto mb-4 text-[#555555]"
  />
  <p
  className="text-lg text-[#555555]"
  >
  No permission templates found.
  </p>
  <p
  className="mt-2 text-sm text-[#555555]"
  >
  Create a new template to get started.
  </p>
  </div>
  </div>
  ) : (
  <div
  className="overflow-hidden border shadow-sm rounded-[14px] bg-[#0A0A0A] border-[#1A1A1A]"
  >
  <div className="overflow-x-auto">
  <table
  className="min-w-full divide-y divide-[#1A1A1A]"
  >
  <thead
  className="bg-[#111111]"
  >
  <tr>
  {[
  "Template Name",
  "Description",
  "Assigned Permissions",
  "No. of Users",
  "Actions",
  ].map((heading) => (
  <th
  key={heading}
  scope="col"
  className="px-4 py-3 text-xs font-medium tracking-wider text-left uppercase text-[#999999]"
  >
  {heading}
  </th>
  ))}
  </tr>
  </thead>
  <tbody
  className={
  "bg-[#0A0A0A] divide-[#1A1A1A]"
  }
  >
  {filteredTemplates.map((template) => {
  const sportIds = new Set(
  template.permissions?.map((p) => p.sportId) || []
  );
  const teamIds = new Set(
  template.permissions?.map((p) => p.teamId) || []
  );
  const numRoutes =
  template.permissions?.filter((p) => p.routePath)
  .length || 0;

  return (
  <tr
  key={template.id}
  className="transition-colors hover:bg-[#111111]"
  >
  <td className="px-4 py-3 text-left">
  <div className="flex items-center space-x-3">
  <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-br from-[#E8B800] to-[#D4A800]">
  <FileText className="w-4 h-4 text-[#F5F5F5]" />
  </div>
  <div className="flex-1 min-w-0 text-left">
  <p
  className="text-sm font-medium truncate text-[#F5F5F5]"
  >
  {template.name}
  </p>
  <p
  className="text-xs truncate text-[#555555]"
  >
  Created{" "}
  {new Date(
  template.createdAt
  ).toLocaleDateString()}
  </p>
  </div>
  </div>
  </td>
  <td className="px-4 py-3 text-left">
  <p
  className="max-w-xs text-sm truncate text-[#555555]"
  title={template.description}
  >
  {template.description || "No description"}
  </p>
  </td>
  <td className="px-4 py-3 text-left">
  <div className="flex flex-wrap gap-1">
  <span className="px-2 py-1 text-xs font-medium text-[#E8B800] bg-[#E8B800]/20 rounded-full">
  {sportIds.size}S
  </span>
  <span className="px-2 py-1 text-xs font-medium text-green-800 bg-green-100 rounded-full">
  {teamIds.size}T
  </span>
  <span className="px-2 py-1 text-xs font-medium text-purple-800 bg-purple-100 rounded-full">
  {numRoutes}R
  </span>
  </div>
  </td>
  <td className="px-4 py-3 text-left">
  <span
  className="text-sm font-medium text-[#999999]"
  >
  {template.userCount || 0}
  </span>
  </td>
  <td className="px-4 py-3 text-left">
  <div className="flex items-center space-x-2">
  <button
  onClick={() =>
  fetchTemplateDetailsForEdit(template.id)
  }
  disabled={loadingTemplateDetails}
  className="text-xs font-medium text-[#555555] hover:text-[#E8B800]"
  >
  <Edit size={18} strokeWidth={2} />
  </button>
  <button
  onClick={() => deleteTemplate(template.id)}
  className="p-1.5 rounded-md transition-colors text-[#555555] hover:text-red-400 hover:bg-[#111111]"
  title="Delete template"
  >
  <Trash2 size={18} strokeWidth={2} />
  </button>
  </div>
  </td>
  </tr>
  );
  })}
  </tbody>
  </table>
  </div>
  </div>
  )}
  </div>
  )}

  {/* this will open model either for add new templete or updated the existing one */}
  {activeTab === "templates" && isTemplateModalOpen && (
  <div className="flex items-center justify-center w-full min-h-screen">
  <PermissionTemplateModal
  isTemplateModalOpen={isTemplateModalOpen}
  onClose={() => setIsTemplateModalOpen(false)}
  onSubmit={
  mode === "add" ? handleCreateTemplate : handleUpdateTemplate
  }
  templateData={mode === "add" ? newTemplate : editingTemplateData}
  setTemplateData={
  mode === "add" ? setNewTemplate : setEditingTemplateData
  }
  isSubmitting={isSubmitting}
  templateError={templateError}
  adminRoutes={adminRoutes}
  enabledSports={enabledSports}
  sports={sports}
  setSports={setSports}
  isEditingTemplate={isEditingTemplate}
  setIsEditingTemplate={setIsEditingTemplate}
  updatingTemplate={updatingTemplate}
  editingTemplateData={editingTemplateData}
  togglePermission={togglePermission}
  toggleRoutePermission={toggleRoutePermission}
  isPermissionSelected={isPermissionSelected}
  isRoutePermissionSelected={isRoutePermissionSelected}
  teamsData={teamsData}
  loadingEnabledSports={loadingEnabledSports}
  loadingTeams={loadingTeams}
  expandedSports={expandedSports}
  toggleSportExpansion={toggleSportExpansion}
  isSportExpanded={isSportExpanded}
  setIsSportExpanded={setIsSportExpanded}
  updateTemplate={updateTemplate}
  prepareEditTemplate={prepareEditTemplate}
  deleteTemplate={deleteTemplate}
  mode={mode}
  handleSportCheckBox={handleSportCheckBox}
  />
  </div>
  )}

  {/* Sports Tab - List View */}
  {activeTab === "sports" && sportsView === "list" && (
  <div className="space-y-6">
  {/* Search + Filters Card */}
  <div
  className="p-6 border shadow-sm rounded-[14px] bg-[#0A0A0A] border-[#1A1A1A]"
  >
  <div className="flex flex-col gap-4 space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
  <div className="flex-1 w-full">
  <div className="relative">
  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
  <Search
  className="w-5 h-5 text-[#999999]"
  />
  </div>
  <input
  type="search"
  className="w-full py-2 pl-10 pr-3 text-sm transition-colors border rounded-lg focus:outline-none text-[#999999] border-[#1A1A1A] focus:border-[#E8B800] bg-[#0A0A0A] placeholder-[#555555]"
  placeholder="Search users by name or email..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  />
  </div>
  </div>

  {/* Filters + Buttons */}
  <div
  className="flex items-center space-x-4 text-sm text-[#F5F5F5]"
  >
  <CustomSelect
  options={[
  { value: "all", label: "All Status" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  ]}
  value={activeFilterTab}
  onChange={setActiveFilterTab}
  classes="w-28 relative"
  />

  {/* Refresh Button */}
  <button
  onClick={fetchSports}
  className="flex items-center px-4 py-2.5 transition-all duration-200 shadow-sm bg-[#111111] text-[#999999] hover:bg-[rgba(255,255,255,0.06)]"
  >
  <RefreshCw className="w-4 h-4 mr-2" strokeWidth={3} />
  </button>

  {/* Add Sport Button (no dark mode change, keep yellow gradient) */}
  <button
  onClick={() => setIsSportModalOpen(true)}
  className="flex items-center px-4 py-2.5 bg-gradient-to-r from-[#E8B800] to-[#D4A800] text-black rounded-lg hover:from-[#C49B00] hover:to-[#C49B00] transition-all duration-200 shadow-lg hover:shadow-xl"
  >
  <Plus className="w-4 h-4 mr-2" />
  Add Sport
  </button>
  </div>
  </div>
  </div>

  {/* Error Message */}
  {sportError && (
  <div
  className="px-4 py-3 border rounded-lg shadow-sm bg-red-900/40 border-red-800 text-red-300"
  >
  <div className="flex items-center">
  <AlertCircle className="flex-shrink-0 w-5 h-5 mr-2" />
  <span>{sportError}</span>
  </div>
  </div>
  )}

  {/* Loading + Empty State */}
  {loadingSports ? (
  <div
  className="p-12 border shadow-sm rounded-[14px] bg-[#0A0A0A] border-[#1A1A1A]"
  >
  <div className="text-center">
  <div className="w-12 h-12 mx-auto border-b-2 border-[#E8B800] rounded-full animate-spin"></div>
  <p
  className="mt-4 text-[#999999]"
  >
  Loading sports...
  </p>
  </div>
  </div>
  ) : filteredSports.length === 0 ? (
  <div
  className="p-12 border shadow-sm rounded-[14px] bg-[#0A0A0A] border-[#1A1A1A]"
  >
  <div className="text-center">
  <Shield
  className="w-12 h-12 mx-auto mb-4 text-[#555555]"
  />
  <p
  className="text-lg text-[#555555]"
  >
  No sports found.
  </p>
  <p
  className="mt-2 text-sm text-[#555555]"
  >
  Add a new sport to get started.
  </p>
  </div>
  </div>
  ) : (
  <div
  className="overflow-hidden border shadow-sm rounded-[14px] bg-[#0A0A0A] border-[#1A1A1A]"
  >
  <div className="overflow-x-auto">
  <table
  className="min-w-full divide-y divide-[#1A1A1A]"
  >
  <thead
  className="bg-[#111111]"
  >
  <tr>
  {[
  "Sport Name",
  "Code",
  "Status",
  "Report Access",
  "Date Created",
  "Actions",
  ].map((heading) => (
  <th
  key={heading}
  className="px-4 py-3 text-xs font-medium tracking-wider text-left uppercase text-[#999999]"
  >
  {heading}
  </th>
  ))}
  </tr>
  </thead>
  <tbody
  className="bg-[#0A0A0A] divide-[#1A1A1A]"
  >
  {filteredSports.map((sport) => {
  const sportTeams = teamsData[sport.code] || [];
  const isExpanded = expandedSports.includes(sport.id);
  const isLoadingTeams =
  loadingTeams && isExpanded && sportTeams.length === 0;

  return (
  <React.Fragment key={sport.id}>
  <tr
  className="transition-colors hover:bg-[#111111]"
  >
  {/* Sport Name */}
  <td className="px-4 py-3 text-left">
  <div className="flex items-center space-x-3">
  <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-br from-[#E8B800] to-[#D4A800]">
  <Shield className="w-4 h-4 text-[#F5F5F5]" />
  </div>
  <div className="flex-1 min-w-0 text-left">
  <div className="flex items-center space-x-2">
  <p
  className="text-sm font-medium text-[#F5F5F5]"
  >
  {sport.name}
  </p>
  <button
  onClick={() =>
  toggleSportExpansion(sport.id)
  }
  className="p-1 rounded transition-colors text-[#555555] hover:text-[#F5F5F5]"
  >
  {isExpanded ? (
  <ChevronUp size={16} />
  ) : (
  <ChevronDown size={16} />
  )}
  </button>
  </div>
  </div>
  </div>
  </td>

  {/* Code */}
  <td className="px-4 py-3 text-left">
  <span
  className="px-2 py-1 text-xs font-medium rounded-full bg-[#111111] text-[#999999]"
  >
  {sport.code}
  </span>
  </td>

  {/* Status */}
  <td className="px-4 py-3 text-left">
  <span
  className={`px-2 py-1 text-xs font-medium rounded-full ${
  sport.isEnable
  ? "bg-green-900 text-green-300"
  : "bg-[#111111] text-[#999999]"
  }`}
  >
  {sport.isEnable ? "Active" : "Inactive"}
  </span>
  </td>

  {/* Report Access */}
  <td className="px-4 py-3 text-left">
  <div className="flex items-center space-x-2">
  {isLoadingTeams ? (
  <span
  className="flex items-center text-xs text-[#555555]"
  >
  <div className="w-3 h-3 mr-1 border border-[#1A1A1A] rounded-full animate-spin border-t-gray-600"></div>
  Loading...
  </span>
  ) : sportTeams.length > 0 ? (
  <span
  className="px-2 py-1 text-xs font-medium rounded-full bg-blue-900 text-blue-300"
  >
  {sportTeams.length} team
  {sportTeams.length !== 1 ? "s" : ""}
  </span>
  ) : sport.code ? (
  <button
  onClick={() =>
  fetchTeamsForSport(sport.code)
  }
  className="text-xs font-medium text-[#E8B800] hover:text-[#E8B800]"
  >
  Fetch Teams
  </button>
  ) : (
  <span
  className="text-xs text-[#555555]"
  >
  No code
  </span>
  )}
  </div>
  </td>

  {/* Date */}
  <td className="px-4 py-3 text-left">
  <span
  className="text-sm text-[#555555]"
  >
  {new Date(
  sport.created_at
  ).toLocaleDateString()}
  </span>
  </td>

  {/* Actions */}
  <td className="px-4 py-3 text-left">
  <div className="flex items-center space-x-2">
  <button
  onClick={() => {
  setEditingSport(sport);
  setIsSportModalOpen(true);
  }}
  className="p-1.5 rounded-md transition-colors text-[#555555] hover:text-[#E8B800] hover:bg-[#111111]"
  title="Edit sport"
  >
  <Edit size={14} />
  </button>
  <button
  onClick={() => deleteSport(sport.id)}
  className="p-1.5 rounded-md transition-colors text-[#555555] hover:text-red-400 hover:bg-[#111111]"
  title="Delete sport"
  >
  <Trash2 size={14} />
  </button>
  </div>
  </td>
  </tr>

  {/* Expanded Teams View */}
  {isExpanded && (
  <tr
  className={
  "bg-[#111111]"
  }
  >
  <td colSpan="6" className="px-8 py-4">
  {!sport.code ? (
  <div
  className="py-4 text-center text-[#E8B800]"
  >
  <AlertCircle className="w-6 h-6 mx-auto mb-2" />
  <p className="text-sm">
  This sport needs a code to fetch teams.
  </p>
  </div>
  ) : isLoadingTeams ? (
  <div className="py-6 text-center">
  <div className="w-6 h-6 mx-auto border-b-2 border-[#E8B800] rounded-full animate-spin"></div>
  <p
  className="mt-2 text-sm text-[#999999]"
  >
  Loading teams for {sport.code}...
  </p>
  </div>
  ) : sportTeams.length > 0 ? (
  /* Teams Table */
  <div>
  <div className="flex items-center justify-between mb-4">
  <h4
  className="text-sm font-medium text-[#F5F5F5]"
  >
  Teams for {sport.name} (
  {sportTeams.length})
  </h4>
  <button
  onClick={() =>
  fetchTeamsForSport(sport.code)
  }
  className="text-xs font-medium text-[#E8B800] hover:text-[#E8B800]"
  >
  Refresh Teams
  </button>
  </div>

  <div className="overflow-x-auto">
  <table
  className="min-w-full border divide-y rounded-lg bg-[#0A0A0A] border-[#1A1A1A] divide-[#1A1A1A]"
  >
  <thead
  className={
  "bg-[#111111]"
  }
  >
  <tr>
  {[
  "ID",
  "Name",
  "Nickname",
  "Full Name",
  "Abbreviation",
  ].map((heading) => (
  <th
  key={heading}
  className="px-3 py-2 text-xs font-medium text-left uppercase text-[#999999]"
  >
  {heading}
  </th>
  ))}
  </tr>
  </thead>
  <tbody
  className="bg-[#0A0A0A] divide-[#1A1A1A]"
  >
  {sportTeams
  .slice(0, 10)
  .map((team) => (
  <tr
  key={team.TeamID}
  className="transition-colors hover:bg-[#111111]"
  >
  <td
  className="px-3 py-2 text-sm text-[#555555]"
  >
  {team.TeamID}
  </td>
  <td
  className="px-3 py-2 text-sm font-medium text-[#F5F5F5]"
  >
  {team.Name}
  </td>
  <td
  className="px-3 py-2 text-sm text-[#555555]"
  >
  {team.Nickname || "-"}
  </td>
  <td
  className="px-3 py-2 text-sm text-[#555555]"
  >
  {team.FullName || "-"}
  </td>
  <td
  className="px-3 py-2 text-sm text-[#555555]"
  >
  {team.Abbrev || "-"}
  </td>
  </tr>
  ))}
  </tbody>
  </table>
  {sportTeams.length > 10 && (
  <div
  className="mt-3 text-center text-xs text-[#555555]"
  >
  Showing 10 of {sportTeams.length}{" "}
  teams
  </div>
  )}
  </div>
  </div>
  ) : (
  <div
  className="py-6 text-center text-[#555555]"
  >
  <Shield
  className="w-8 h-8 mx-auto mb-2 text-[#555555]"
  />
  <p className="text-sm">
  {sport.code
  ? `No teams found for sport code: ${sport.code}`
  : "This sport needs a code to fetch teams."}
  </p>
  {sport.code && (
  <button
  onClick={() =>
  fetchTeamsForSport(sport.code)
  }
  className="mt-2 text-xs font-medium text-[#E8B800] hover:text-[#E8B800]"
  >
  Try Again
  </button>
  )}
  </div>
  )}
  </td>
  </tr>
  )}
  </React.Fragment>
  );
  })}
  </tbody>
  </table>
  </div>
  </div>
  )}
  </div>
  )}

  {/* Sports Tab - Create Form */}
  {activeTab === "sports" && isSportModalOpen && (
  <div className="flex items-center justify-center w-full min-h-screen">
  <SportModal
  mode="add"
  key="sport-modal"
  isSportModalOpen={isSportModalOpen}
  onClose={() => setIsSportModalOpen(false)}
  onSubmit={createSport}
  newSport={newSport}
  setNewSport={setNewSport}
  error={sportError}
  // isLoading={isCreatingSport}
  onBackToList={() => setSportsView("list")}
  />
  </div>
  )}

  {/* Sports Tab - Edit Form */}
  {activeTab === "sports" && isSportModalOpen && editingSport && (
  <div className="flex items-center justify-center w-full min-h-screen">
  <SportModal
  mode="edit"
  isSportModalOpen={isSportModalOpen}
  onClose={() => setIsSportModalOpen(false)}
  onSubmit={updateSport}
  newSport={editingSport || { name: "", code: "", isEnable: true }}
  setNewSport={setEditingSport}
  error={sportError}
  // isLoading={isUpdatingSport}
  onBackToList={() => setSportsView("list")}
  />
  </div>
  )}

  {/* Modern User Edit Modal */}
  {editingUser && editingUserTemplates && selectedUser && (
  <div
  className="fixed inset-0 z-50 flex items-center justify-center p-3 bg-black/70"
  >
  <div
  className="w-full max-w-md transition-all transform shadow-2xl rounded-[14px] bg-[#111111]"
  >
  {/* Modal Header */}
  <div
  className="px-6 py-2 border-b border-[#1A1A1A]"
  >
  <div className="flex items-center justify-between">
  <div className="flex items-center space-x-3">
  <div>
  <h3
  className="text-base font-bold text-[#F5F5F5]"
  >
  Edit User
  </h3>
  </div>
  </div>
  <button
  onClick={cancelEditingUser}
  className="p-2 rounded-lg transition-colors text-[#555555] hover:text-[#F5F5F5] hover:bg-[#0A0A0A]"
  >
  <X size={20} />
  </button>
  </div>
  </div>

  {/* Modal Body */}
  <div className="px-6 py-3 space-y-2">
  {/* Username Field */}
  <div>
  <label
  className="block mb-3 text-xs font-medium text-[#999999]"
  >
  Username
  </label>
  <input
  type="text"
  value={users.find((u) => u.id === editingUser.id)?.name}
  onChange={(e) =>
  setEditingUser({ ...editingUser, name: e.target.value })
  }
  className="w-full p-2 text-xs transition-all border-2 rounded-lg focus:border-blue-500 focus:ring-blue-500 bg-[#0A0A0A] text-[#F5F5F5] border-[#1A1A1A]"
  />
  </div>

  {/* User Role */}
  <div>
  <label
  className="block mb-3 text-xs font-medium text-[#999999]"
  >
  User Role
  </label>
  <CustomSelect
  options={[
  { value: null, label: "None" },
  { value: "USER", label: "User" },
  { value: "ADMIN", label: "Admin" },
  ]}
  value={editingUser.newRole}
  onChange={(newRole) =>
  setEditingUser({ ...editingUser, newRole })
  }
  classes="w-full relative"
  buttonClass={`p-2 text-xs text-center border-2 rounded-lg transition-all text-[#F5F5F5] border-[#1A1A1A] bg-[#0A0A0A]`}
  dropdownClass={`mt-1 border-2 rounded-lg shadow-lg border-[#1A1A1A] bg-[#0A0A0A]`}
  optionClass={(option) =>
  `p-2 text-center ${
  option.value === editingUser.newRole
  ? "bg-[#111111] text-[#F5F5F5]"
  : "text-[#555555] hover:bg-[#111111]"
  }`
  }
  />
  </div>

  {/* Access Level */}
  <div className="max-w-4xl w-full max-h-[90vh] overflow-hidden">
  <h1
  className="py-1 text-base text-[#F5F5F5]"
  >
  Access Level
  </h1>

  <div className="flex-1 overflow-y-auto">
  {userTemplateError && (
  <div
  className="px-4 py-2 mb-6 text-xs border rounded-lg shadow-sm bg-red-900/40 border-red-800 text-red-300"
  >
  <div className="flex items-center">
  <AlertCircle className="flex-shrink-0 w-5 h-5 mr-2" />
  <span>{userTemplateError}</span>
  </div>
  </div>
  )}

  {loadingTemplates ? (
  <div className="py-6 text-center">
  <div className="w-12 h-12 mx-auto border-b-2 border-blue-600 rounded-full animate-spin"></div>
  <p
  className="mt-4 text-xs text-[#999999]"
  >
  Loading templates...
  </p>
  </div>
  ) : permissionTemplates.length === 0 ? (
  <div className="py-8 text-xs text-center">
  <FileText
  className="w-16 h-16 mx-auto mb-4 text-[#999999]"
  />
  <h3
  className="mb-2 text-lg font-medium text-[#F5F5F5]"
  >
  No Templates Available
  </h3>
  <p
  className={
  "text-[#555555]"
  }
  >
  Create permission templates first to assign them to
  users.
  </p>
  </div>
  ) : (
  <div className="space-y-3">
  {/* Selected Count */}
  {selectedTemplateIds.length > 0 && (
  <div
  className="p-3 mb-6 border rounded-lg bg-blue-900/40 border-blue-700"
  >
  <div className="flex items-center justify-between">
  <div className="flex items-center space-x-3">
  <div className="flex items-center justify-center w-8 h-8 bg-blue-500 rounded-full">
  <span className="text-sm font-semibold text-[#F5F5F5]">
  {selectedTemplateIds.length}
  </span>
  </div>
  <div>
  <p
  className="text-xs font-medium text-blue-300"
  >
  {selectedTemplateIds.length} template
  {selectedTemplateIds.length !== 1
  ? "s"
  : ""}{" "}
  selected
  </p>
  <p
  className="text-xs text-blue-400"
  >
  Templates will be assigned to{" "}
  {selectedUser.name}
  </p>
  </div>
  </div>
  <button
  onClick={() => setSelectedTemplateIds([])}
  className="text-xs font-medium text-blue-300 hover:text-blue-200"
  >
  Clear All
  </button>
  </div>
  </div>
  )}

  {/* Templates Grid */}
  <div className="grid grid-cols-1 gap-2 overflow-y-auto min-h-44 max-h-52">
  {permissionTemplates.map((template) => {
  const isSelected = selectedTemplateIds.includes(
  template.id
  );

  return (
  <div
  key={template.id}
  className={`border rounded-lg p-2 cursor-pointer transition-all duration-200 ${
  isSelected
  ? "border-blue-500 bg-blue-900/30 shadow-sm"
  : "border-[#1A1A1A] hover:border-[#1A1A1A]"
  }`}
  onClick={() =>
  toggleTemplateSelection(template.id)
  }
  >
  <div className="flex items-center justify-between mb-2">
  <h4
  className={`font-medium text-xs truncate ${
  isSelected
  ? "text-blue-500"
  : "text-[#F5F5F5]"
  }`}
  >
  {template.name}
  </h4>
  <div
  className={`w-4 h-4 rounded-full border flex items-center justify-center flex-shrink-0 ml-2 ${
  isSelected
  ? "border-blue-500 bg-blue-500"
  : "border-[#1A1A1A]"
  }`}
  >
  {isSelected && (
  <div className="w-1.5 h-1.5 bg-[#111111] rounded-full"></div>
  )}
  </div>
  </div>

  {/* Permissions & User Count */}
  <div className="flex items-center justify-between">
  <div className="flex flex-wrap gap-1 mb-2">
  {[
  {
  label: `${
  template.permissions?.filter(
  (p) => p.sportId
  ).length
  }S`,
  color: "blue",
  },
  {
  label: `${
  template.permissions?.filter(
  (p) => p.teamId
  ).length
  }T`,
  color: "green",
  },
  {
  label: `${
  template.permissions?.filter(
  (p) => p.routePath
  ).length
  }R`,
  color: "purple",
  },
  ].map(({ label, color }) => (
  <span
  key={label}
  className={`px-1.5 py-0.5 text-xs rounded ${
  isSelected
  ? `bg-${color}-100 text-${color}-700`
  : "bg-[#0A0A0A] text-[#555555]"
  }`}
  >
  {label}
  </span>
  ))}
  </div>
  <div
  className="flex items-center text-xs text-[#555555]"
  >
  <UserCheck size={10} className="mr-1" />
  {template.userCount || 0}
  </div>
  </div>
  </div>
  );
  })}
  </div>
  </div>
  )}
  </div>
  </div>

  {/* Approval Status */}
  <div>
  <label
  className="block mb-3 text-sm font-medium text-[#999999]"
  >
  Approval Status
  </label>
  <div className="grid grid-cols-2 gap-3">
  <button
  onClick={() =>
  setEditingUser({ ...editingUser, newApproval: true })
  }
  className={`p-2 flex space-x-2 justify-center items-center border-2 rounded-lg transition-all text-[#F5F5F5] border-[#1A1A1A] ${
  editingUser.newApproval === true
  ? "border-[#E8B800] bg-[#E8B800] text-black"
  : "hover:border-[#333333] hover:bg-[rgba(255,255,255,0.04)]"
  }`}
  >
  <Check size={18} strokeWidth={2.75} />
  <div className="text-sm font-medium">Approved</div>
  </button>

  <button
  onClick={() =>
  setEditingUser({ ...editingUser, newApproval: false })
  }
  className={`p-2 flex space-x-2 justify-center items-center border-2 rounded-lg transition-all text-[#F5F5F5] border-[#1A1A1A] ${
  editingUser.newApproval === false
  ? "border-[#F5F5F5] bg-[#0A0A0A] text-[#F5F5F5]"
  : "hover:border-[#1A1A1A] hover:bg-[#0A0A0A]"
  }`}
  >
  <X size={18} strokeWidth={2.75} />
  <div className="text-sm font-medium">Decline</div>
  </button>
  </div>
  </div>
  </div>

  {/* Modal Footer */}
  <div
  className="flex justify-end px-6 py-4 space-x-3 border-t border-[#1A1A1A]"
  >
  <button
  onClick={cancelEditingUser}
  disabled={updatingUser}
  className="px-4 py-2 text-sm font-medium rounded-lg transition-colors bg-[#0A0A0A] text-[#999999] border border-[#1A1A1A] hover:bg-[#111111] disabled:opacity-50"
  >
  Cancel
  </button>

  <button
  onClick={saveUserChanges}
  disabled={updatingUser}
  className="px-5 py-3 text-sm font-medium text-black transition-all rounded-lg bg-gradient-to-r from-[#E8B800] to-[#D4A800] hover:from-[#D4A800] hover:to-[#C49B00] disabled:opacity-50 disabled:cursor-not-allowed"
  >
  {updatingUser ? (
  <span className="flex items-center">
  <div className="w-4 h-4 mr-2 border-b-2 border-[#F5F5F5] rounded-full animate-spin"></div>
  Saving...
  </span>
  ) : (
  "Save Changes"
  )}
  </button>
  </div>
  </div>
  </div>
  )}
  </div>
  </div>
  );
};

export default Permissions;
